import React, { useState, useRef } from "react"
import {
  Container,
  Card,
  CardBody,
  Row,
  Col,
  Input,
  Label,
  Button,
  FormGroup,
  Nav,
  NavItem,
  NavLink,
  Spinner,
  Table,
  Badge,
} from "reactstrap"
import Modal from "react-bootstrap/Modal"
import classnames from "classnames"
import MetaTags from "react-meta-tags"
import { Formik, Form } from "formik"
import * as Yup from "yup"
import { ToastContainer, toast } from "react-toastify"
import PhoneInput from "react-phone-number-input"
import Select from "react-select"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { useEffect } from "react"
import { withRouter, useParams, useHistory } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
//Import Styles
import "./styles.scss"
import "react-phone-number-input/style.css"
import EventDetails from "./EventDetails"
import FollowUpDetails from "./FollowUpDetails"
import clientAction from "../../store/Y2xpZW50/actions"
import quotationAction from "../../store/cXVvdGF0/actions"
import * as eventCompleteAction from "../../store/ZXZlbnRDb21wbGV0ZWQ/actions"
import * as eventCancelAction from "../../store/ZXZlbnRDYW5jZWw/actions"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import { isEmpty, get } from "lodash"
import QuotationDetails from "./Quotation"
import FollowUpHistory from "./FollowUpHistory"
import QuotationHistory from "./QuotationHistory"
import TeamSchedulingDetails from "../EventCoordination/TeamScheduling"
import EcClientDetails from "../EventCoordination/EcClient"
import EcEventDetails from "../EventCoordination/EcEvents"
import EcServiceDetails from "../EventCoordination/EcService"
import EcDeliverableDetails from "../EventCoordination/EcDeliverable"
import EcClientCheckList from "../EventCoordination/EcCheckList"
import SpecialInstruction from "../EventCoordination/EcSpecialInstruction"
import Sales from "./Sales"
import SimpleReactValidator from "simple-react-validator"
import moment from "moment"
import Notification from "./Notification"
import ClientQuestionsList from "./QuestionList"
import EcEquipmentScheduling from "pages/EventCoordination/EcEquipmentScheduling"
import ECFollowup from "pages/EventCoordination/ECFollowup"
import api from "helpers/Api"
import OperationsSpecialInstructions from "pages/OperationsClientDetails/OperationsSpecialInstructions"
import OperationsFollowup from "pages/OperationsClientDetails/OperationsFollowup"
import OperationsFirstSet from "pages/OperationsClientDetails/OperationsFirstSet"
import OperationsSecondSet from "pages/OperationsClientDetails/OperationsSecondSet"
import OperationsPrint from "pages/OperationsClientDetails/OperationsPrint"
import OperationsDispatch from "pages/OperationsClientDetails/OperationsDispatch"
import OperationsDeliverables from "pages/OperationsClientDetails/OperationsDeliverables"
import OperationsReviews from "pages/OperationsClientDetails/OperationsReviews"
import OperationsClientCheckListQuestions from "pages/OperationsClientDetails/OperationsClientCheckListQuestions"
import OperationsApp from "pages/OperationsClientDetails/OperationsApp"
import CopyDataTeamScheduling from "pages/CopyDataNew/CopyDataTeamScheduling"
import ReactStars from "react-rating-stars-component"
import OperationsCallRecording from "../OperationsClientDetails/OperationsCallRecording"
import * as auditAction from "../../store/c2FsZXNG/actions"
//  import OperationsReviews from "pages/OperationsClientDetails/OperationsReviews"


const ClientDetails = (props) => {
  const { dispatch, location } = props
  console.log(location, "location")
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  // const simpleEngageValidator = useRef(new SimpleReactValidator())
  // const [, forceUpdated] = useState()
  const history = useHistory()

  const moduleModeData =
    !isEmpty(location) && location.state && location.state.mode
      ? location.state.mode
      : "SALES"
  const menuName =
    !isEmpty(location) && location.state && location.state.menuName
      ? location.state.menuName
      : ""
  const modeMenu =
    !isEmpty(location) && location.state && location.state.modeMenu
      ? location.state.modeMenu
      : ""
  // console.log(location, "location")

  const leadByClientDetailsId =
    !isEmpty(location) &&
      !isEmpty(location.state) &&
      location.state != undefined &&
      moduleModeData == "EC"
      ? location.state.leadClientId.clientDetails._id
      : moduleModeData == "SALES" && location.state != undefined
        ? location.state.leadClientId.clientId
        : (moduleModeData == "Operations" && location.state != undefined) ||
          (moduleModeData == "Data" && location.state != undefined)
          ? location.state.leadClientId.clientId
          : ""
  const leadDetailsUuid =
    !isEmpty(location) &&
      !isEmpty(location.state) &&
      location.state != undefined
      ? location.state.leadClientId.leadUuid
      : ""


  // const [pageLoad, setPageload] = useState(false)
  const [managerView, setManagerView] = useState(false)
  const [moduleMode, setModuleMode] = useState("")
  const [customerPageLoad, setCustomerPageload] = useState(false)
  const [customerClientId, setCustomerClientId] = useState("")
  // const [moduleMode, setModuleMode] = useState("")
  const [customerLeadUuid, setCustomerLeadUuid] = useState("")
  // console.log(moduleMode, "moduleMode")
  console.log(managerView, "managerView")

  const [formErrors, setFormErrors] = useState({})

  const [formErrors_2, setFormErrors_2] = useState({})
  const [isSubmit_2, setIsSubmit_2] = useState(false)

  const [useSubmitting, setSetSubmitting] = useState("")
  const [useRedirect, setRedirect] = useState("")
  const [useHandleValues, setHandleValues] = useState("")
  const [multipleLeadId, setMultipleLeadId] = useState("")
  const [eventDataLoading, setEventDataLoading] = useState(false)
  const [eventCoordinatorLoading, setEventCoordinatorLoading] = useState(false)
  //client appearnace rating
  const [clientAppearanceRating, setClientAppearanceRating] = useState("")
  console.log(clientAppearanceRating, "clientAppearance ratings")
  const handleClientAppearanceRating = (e) => {
    setClientAppearanceRating(e)
    const clientAppearance_details = {
      "_id": id,
      "clientAppearanceRating": e
    }
    dispatch(clientAction.addClientAppearance(clientAppearance_details))
    setTimeout(() => {
      dispatch(clientAction.loadRecordClientProfileById({
        mode: "SALES",
        clientId: leadByClientDetailsId,
      }))

    }, 200)
  }

  //Star icons
  const ratingProps = {
    emptyIcon: <i className="far fa-star" style={{ marginRight: "5px" }} />,
    halfIcon: <i className="fa fa-star-half-alt" style={{ marginRight: "5px" }} />,
    filledIcon: <i className="fa fa-star" style={{ marginRight: "5px" }} />,
  }

  useEffect(() => {
    if (!isEmpty(leadByClientDetailsId) && moduleModeData == "SALES") {
      const client = {
        mode: "SALES",
        clientId: leadByClientDetailsId,
      }
      // console.log("sales", "sales call")
      dispatch(clientAction.loadRecordClientProfileById(client))
      setCustomerClientId(leadByClientDetailsId)
      setCustomerLeadUuid(leadDetailsUuid)
    } else if (!isEmpty(leadByClientDetailsId) && moduleModeData == "EC") {
      const client = {
        mode: "EC",
        clientId: leadByClientDetailsId,
      }
      // console.log("EC", "EC call")
      dispatch(clientAction.loadRecordClientProfileById(client))
      setCustomerClientId(leadByClientDetailsId)
      setCustomerLeadUuid(leadDetailsUuid)
    } else if (
      !isEmpty(leadByClientDetailsId) &&
      moduleModeData == "Operations"
    ) {
      const client = {
        mode: "Operations",
        clientId: leadByClientDetailsId,
      }
      // console.log("Operations", "Operations call")
      dispatch(clientAction.loadRecordClientProfileById(client))
      setCustomerClientId(leadByClientDetailsId)
      setCustomerLeadUuid(leadDetailsUuid)
    } else if (!isEmpty(leadByClientDetailsId) && moduleModeData == "Data") {
      const client = {
        mode: "Data",
        clientId: leadByClientDetailsId,
      }
      // console.log("Data", "Data call")
      dispatch(clientAction.loadRecordClientProfileById(client))
      setCustomerClientId(leadByClientDetailsId)
      setCustomerLeadUuid(leadDetailsUuid)
    }
    // if(!isEMpty)
  }, [])
  const getBadgeColor = (value) => {
    if (value.startsWith("ZGP")) return "#46b031" // Green
    if (value.startsWith("ZGT")) return "#0879c4" // Blue
    if (value.startsWith("ZGD")) return "#ffcc00" // Yellow (warning)
    if (value.startsWith("VER")) return "#dc3545" // Red (danger)
    if (value.startsWith("DC")) return "#d3d3d3" // Light Grey
    if (value.startsWith("ZGI")) return "#ffffe0" // Light Yellow
    if (value.startsWith("KS")) return "#a9a9a9" // Dark Grey
    if (value.startsWith("VEN")) return "#FFA500" // Mild Orange
    if (value.startsWith("ZGG")) return "#ffb6c1" // Light Pink
    if (value.startsWith("EMS")) return "#f205af" // Light Green
    if (value.startsWith("PRS")) return "#cb42f5" // Custom Purple
    if (value.startsWith("COM0014")) return "#8fc2a5" // Custom Green
    if (value.startsWith("COM0015")) return "#b9dcfa" // Custom Light Blue

    return "#46b031" // Default color (Green)
  }

  useEffect(() => {
    if (moduleModeData != "Data") {
      dispatch(clientAction.loadRecordClientDetails(id))
      // if (isEmpty(leadByClientDetailsId)) {
      dispatch(clientAction.loadRecords(id))
      // }
      dispatch(quotationAction.loadQuotationList(id))
    }
    setTimeout(() => {
      setModuleMode(moduleModeData)
    }, 1000)
    if (moduleModeData == "EC") {
      setCustomIconActiveTab("Event Coordinator")
    } else if (moduleModeData == "Operations") {
      setCustomIconActiveTab("Operations")
    } else if (moduleModeData == "Data") {
      setCustomIconActiveTab("Data")
    } else {
      setCustomIconActiveTab("Sales")
    }
  }, [])


  const specificDispatch = useDispatch()
  const clientUpdate = useSelector((specificState) => specificState.client)

  const [formData, setFormData] = useState([])
  let { id } = useParams()
  var recordArray = []
  if (
    !customerPageLoad &&
    clientUpdate &&
    clientUpdate.records &&
    clientUpdate.records.length > 0
  ) {
    var records = clientUpdate.records
    recordArray = records.filter((record) => record._id === id)
    recordArray = recordArray[0]
  }

  if (
    isEmpty(leadByClientDetailsId) &&
    recordArray &&
    recordArray.leadUuid &&
    recordArray.clientId
  ) {
    const client = {
      mode: moduleModeData,
      clientId: recordArray.clientId,
    }

    dispatch(clientAction.loadRecordClientProfileById(client))
    if (!customerPageLoad) {
      setCustomerPageload(true)
      setCustomerClientId(recordArray.clientId)
      setCustomerLeadUuid(recordArray.leadUuid)
    }
  }
  const {
    record_client_details = [],
    recordsMetaData = {},

    record_client_profile = {},
  } = clientUpdate

  const sessionUpdate = useSelector((specificState) => specificState.session)
  const quotationUpdate = useSelector(
    (specificState) => specificState.quotation
  )
  const { user = [] } = sessionUpdate
  const { quotationList = [] } = quotationUpdate

  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : []

  const isQuotation = !isEmpty(quotationList) && quotationList[0].isQuotation

  const loginAccess = !isEmpty(user) && user ? user : []
  const salesManagerId = !isEmpty(user) && user.roleId

  useEffect(() => {
    if (salesManagerId === "6320da65812dfec5383565f4" || isQuotation === true) {
      setManagerView(true)
    } else {
      setManagerView(false)
    }
  }, [salesManagerId, quotationList])

  //Lead and multiple lead details
  const [leadDetails, setLeadDetails] = useState("")
  console.log("zgPlusClient:", leadDetails)
  const [multipleLeadDetails, setMultipleLeadDetails] = useState("")
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const value = !isEmpty(record_client_profile) &&
      !isEmpty(leadDetails) &&
      leadDetails[0].clientAppearanceRating
      ? leadDetails[0].clientAppearanceRating
      : 0
    setClientAppearanceRating(value)
  }, [leadDetails])
  //EVent complete mdoal section start
  const [eventCompleteModal, setEventCompleteModal] = useState(false)
  const [eventCompleteMode, setEventCompleteMode] = useState("Processing")
  const [eventNotes, setEventNotes] = useState("")
  const [attachment, setAttachment] = useState([])
  const handleEventClose = () => setEventCompleteModal(false)
  console.log(leadDetails, "leadDetails")
  //Loading based on tab selection
  useEffect(() => {
    if (loading === true) {
      setCustomerPageload(true)
      if (moduleMode == "EC") {
        setEventTab("Client / Events")
        // setCustomIconActiveTab("Event Coordinator")
      } else {
        setActiveTab("Client / Events")
        // setCustomIconActiveTab("Sales")
      }
      if (moduleMode != "Data") {
        dispatch(clientAction.loadRecordClientDetails(multipleLeadId))
        dispatch(quotationAction.loadQuotationList(id))
        dispatch(clientAction.loadRecords(id))
      }
      let payload = { status: "active", id: id }
      api
        .post(`/get_all_lead`, payload)
        .then((response) => {
          if (response && response.data && response.data.data.length > 0) {
            var records = response.data.data
            recordArray = records.filter((record) => record._id === id)
            recordArray = recordArray[0]
          }
          if (recordArray && recordArray.clientId) {
            const client = {
              mode: moduleMode,
              clientId: leadByClientDetailsId
                ? leadByClientDetailsId
                : recordArray.clientId,
            }
            // console.log(client, "client payload")
            api
              .post("/get_all_lead_by_client", client)
              .then((res) => {
                // console.log(res.data, "response")
                setTimeout(() => {
                  const leadDetails = !isEmpty(res.data.data)
                    ? res.data.data.leadDetails.filter(
                      (data) => data.leadId === multipleLeadId
                    )
                    : []
                  setLeadDetails(leadDetails)

                  const multipleLeadDetails = !isEmpty(res.data.data)
                    ? res.data.data.leadDetails.filter(
                      (data) => data.leadId !== multipleLeadId
                    )
                    : []
                  setMultipleLeadDetails(multipleLeadDetails)
                }, 2500)
                res.data
              })
              .catch((error) => Promise.reject(error))
            dispatch(clientAction.loadRecordClientProfileById(client))
            if (!customerPageLoad) {
              setCustomerPageload(true)
              setCustomerClientId(recordArray.clientId)
              setCustomerLeadUuid(recordArray.leadUuid)
            }
          }
          response.data
        })
        .catch((error) => Promise.reject(error))
    }
  }, [loading])
  //followup history 
  const [followupHistoryModal, setFollowupHistoryModal] = useState(false)
  const handleFollowupHistoryModal = () => {
    setFollowupHistoryModal(false)
  }
  const handleZgFollowupHistory = (data) => {
    const payload = {
      leadId: data
    }
    setFollowupHistoryModal(true)
    setTimeout(() => {
      dispatch(auditAction.loadFollowupHistory(payload))
    }, 500)
  }
  const salesFollowupUpdate = useSelector(
    (specificstate) => specificstate.salesfollowup
  )
  const { followup_history = [] } = salesFollowupUpdate
  // console.log(multipleLeadId, "multipleLeadId")
  //EVent completion attachment
  const handleChangeBookingAttachment = async (e) => {
    if (e.target.files) {
      var file = e.target.files
      var fileArray = Array.from(file)

      var eventAttachmentValue = attachment

      for (let x in fileArray) {
        const formData = new FormData()
        formData.append("file", fileArray[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              eventAttachmentValue.push(res.data.data)
              await setAttachment(eventAttachmentValue)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
      // setFFStrategy([])
    }
  }
  //bride attachment
  const [uploadBrideInput, setUploadBrideInput] = useState([])
  const [fileName, setFileName] = useState("")
  const [fileLength, setFileLength] = useState("")
  const uploadBrideChange = async (e) => {
    if (e.target.files) {
      const fileArrayDetails = Array.from(e.target.files)

      const uploadedFiles = []
      const uploadedFileNames = []

      for (const file of fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", file)

        try {
          const res = await api.post("/image_upload", formData)
          if (res && res.data && res.data.data) {
            uploadedFiles.push(res.data.data)
            uploadedFileNames.push(file.name) // Track the file name
          }
        } catch (error) {
          console.error("File upload failed", error)
        }
      }

      // Update the state with the new files and their names
      setUploadBrideInput((prev) => [...prev, ...uploadedFiles])
      setFileName((prev) => prev ? `${prev}, ${uploadedFileNames.join(", ")}` : uploadedFileNames.join(", "))
      setFileLength((prev) => prev + uploadedFiles.length)

    }
  }


  const [uploadGroomInput, setUploadGroomInput] = useState([])
  const [fileGroomName, setFileGroomName] = useState("")
  const [fileGroomLength, setFileGroomLength] = useState(0)

  const uploadGroomChange = async (e) => {
    if (e.target.files) {
      const fileArrayDetails = Array.from(e.target.files)

      // Track the new uploads
      const uploadedFiles = []
      const uploadedFileNames = []

      for (const file of fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", file)

        try {
          const res = await api.post("/image_upload", formData)
          if (res?.data?.data) {
            uploadedFiles.push(res.data.data)
            uploadedFileNames.push(file.name)
          }
        } catch (error) {
          console.error("File upload failed", error)
        }
      }

      // Update the  uploaded files 
      setUploadGroomInput((prev) => [...prev, ...uploadedFiles])

      // Update the file count 
      setFileGroomLength((prev) => prev + uploadedFiles.length)

      // Update the file names
      setFileGroomName((prev) => prev ? `${prev}, ${uploadedFileNames.join(", ")}` : uploadedFileNames.join(", "))
    }
  }


  const eventCompletionSubmit = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const eventCompleteDetails = {
        leadId: id,
        completeStatus: "complete",
        remarks: eventNotes,
        attachments: attachment[0],
      }
      // console.log(eventCompleteDetails, "eventCompleteDetails")
      specificDispatch(
        eventCompleteAction.updateEventComplete(eventCompleteDetails)
      )
      setTimeout(() => {
        specificDispatch(eventCompleteAction.loadEventCompleteList())

        setEventCompleteModal(false)
      }, 1000)

      setTimeout(() => {
        history.push("/event-completed-list")
      }, 2000)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setEventCompleteModal(true)
    }
  }

  //Event Cancel modal section start
  const [eventCancelModal, setEventCancelModal] = useState(false)
  const [eventCancelNotes, setEventCancelNotes] = useState("")
  const [eventCancelAttachment, setEventCancelAttachment] = useState([])
  const handleEventCancelModal = () => setEventCancelModal(false)

  //Event completion attachment
  const handleChangeCancelAttachment = async (e) => {
    if (e.target.files) {
      var file = e.target.files
      var fileArray = Array.from(file)

      var eventAttachmentValue = eventCancelAttachment

      for (let x in fileArray) {
        const formData = new FormData()
        formData.append("file", fileArray[x])
        api
          .post("/image_upload", formData)
          .then(async (res) => {
            if (res && res.data && res.data.data) {
              eventAttachmentValue.push(res.data.data)
              await setEventCancelAttachment(eventAttachmentValue)
            } else {
              alert("Upload Failed!. Please try again")
            }
          })
          .catch(() => {
            alert("Unable to Upload file")
          })
      }
    }
  }

  //Event cancel submission

  const eventCancelSubmit = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const eventCancelDetails = {
        leadId: id,
        eventCancelRemarks: eventCancelNotes,
        eventCancelattachment: eventCancelAttachment,
      }
      specificDispatch(eventCancelAction.updateEventCancel(eventCancelDetails))
      setLoading(true)
      setTimeout(() => {
        specificDispatch(
          eventCancelAction.loadEventCancelledList({
            page: 1,
            limit: 50,
          })
        )
        setEventCancelModal(false)
      }, 1000)
      setTimeout(() => {
        history.push("/event-cancelled-list")
        setLoading(false)
      }, 2500)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setEventCancelModal(true)
    }
  }
  console.log(history)
  //Event cancel section end

  //Add new lead Modal section start
  const [newLeadModal, setNewLeadModal] = useState(false)
  const [clientDetailsChecked, setClientDetailsChecked] = useState("")
  const handleNewLeadClose = () => setNewLeadModal(false)

  const newLeadCreationConfirm = () => {
    const newLead = {
      leadId: id,
      isClientDetailAllow: clientDetailsChecked,
    }
    specificDispatch(clientAction.createNewLead(newLead))
    setTimeout(() => {
      toast.success("New Lead Created Successfully")
      setNewLeadModal(false)
    }, 1000)
  }

  //Add new lead Modal section end

  //Service confirmation start
  const serviceConfirmationPreview = () => {
    var leadNoValue = leadDetails[0].leadNumber + "_" + leadDetails[0].company
    let bufferObj = Buffer.from(leadNoValue, "utf8")
    let base64String = bufferObj.toString("base64")

    var path =
      "https://alphamail.in/lo/sc" + "?type=" + id + "&&key=" + base64String
    window.open(path)
  }
  const [nonWeddingProfile, setNonWeddingProfile] = useState([])
  useEffect(() => {
    if (!isEmpty(record_client_profile)) {
      const leadDetails = !isEmpty(record_client_profile)
        ? record_client_profile.leadDetails.filter((data) => data.leadId === id)
        : []

      setLeadDetails(leadDetails)
      const multipleLeadDetails = !isEmpty(record_client_profile)
        ? record_client_profile.leadDetails.filter((data) => data.leadId !== id)
        : []
      setMultipleLeadDetails(multipleLeadDetails)
    }
  }, [record_client_profile])

  //Client Data Section
  const [profileData, setProfileData] = useState({
    status: 1,
    leadId: id,
    type: "couple",
    bride: {
      brideName: "",
      brideMobileNo: "",
      brideWhatsappNo: "",
      brideEmailId: "",
      brideProfile: [],
      brideRemarks: "",
      brideFbLink: "",
      brideInstaLink: "",
    },
    groom: {
      groomName: "",
      groomMobileNo: "",
      groomWhatsappNo: "",
      groomEmailId: "",
      groomProfile: [],
      groomRemarks: "",
      groomFbLink: "",
      groomInstaLink: "",
    },
  })

  const handleChange = (e) => {
    setProfileData({
      ...profileData,
      bride: {
        ...profileData.bride,
        [e.target.name]: e.target.value,
      },
      groom: {
        ...profileData.groom,
        [e.target.name]: e.target.value,
      },
    })
  }

  const [brideProfile, setBrideProfile] = useState([])
  const [groomProfile, setGroomProfile] = useState([])
  console.log(profileData, "profileData")
  console.log(profileData.bride.brideMobileNo.length, "profileData")
  const addClient = () => {
    setProfileData({
      status: 1,
      leadId: id,
      type: "couple",
      bride: {
        brideName: "",
        brideMobileNo: "+91",
        brideWhatsappNo: "+91",
        brideEmailId: "",
        brideProfile: [],
        brideRemarks: "",
        brideFbLink: "",
        brideInstaLink: "",
      },
      groom: {
        groomName: "",
        groomMobileNo: "+91",
        groomWhatsappNo: "+91",
        groomEmailId: "",
        groomProfile: [],
        groomRemarks: "",
        groomFbLink: "",
        groomInstaLink: "",
      },
    })
    setBrideProfile([])
    setGroomProfile([])
    setOpenModal(true)
    setUploadBrideInput([])
    setUploadGroomInput([])
    setFileName("")
    setFileLength(0)
    setFileGroomName('')
    setFileGroomLength(0)
  }

  const modeData = moduleMode === "EC" ? "Event Coordinator" : "Sales"

  const [customIconActiveTab, setCustomIconActiveTab] = useState(modeData)

  //Button Tabs
  const [activeTab, setActiveTab] = useState("Client / Events")

  const [eventTab, setEventTab] = useState("Client / Events")
  const [operationTab, setOperationTab] = useState("Client / Events / SI")
  const [dataTab, setDataTab] = useState("Data Copy")
  //Form Modal
  const [openModal, setOpenModal] = useState(false)
  const [clientInputErrors, setClientInputErrors] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  //Client Form submission
  const handleSubmit = (e) => {
    e.preventDefault()
    if (
      profileData.bride.brideMobileNo.length < 12 ||
      profileData.bride.brideWhatsappNo.length < 12 ||
      profileData.groom.groomMobileNo.length < 12 ||
      profileData.groom.groomWhatsappNo.length < 12
    ) {
      setClientInputErrors(true)
      setOpenModal(true)
    } else {
      const profileObject = {
        status: 1,
        leadId: profileData.leadId,
        type: "couple",
        bride: {
          brideName: profileData.bride.brideName,
          brideMobileNo: profileData.bride.brideMobileNo,
          brideWhatsappNo: profileData.bride.brideWhatsappNo,
          brideEmailId: profileData.bride.brideEmailId,
          brideProfile: brideProfile.label,
          brideProfileRemark: profileData.bride.brideRemarks,
          brideFbLink: profileData.bride.brideFbLink,
          brideInstLink: profileData.bride.brideInstaLink,
          brideAttachments: uploadBrideInput
        },
        groom: {
          groomName: profileData.groom.groomName,
          groomMobileNo: profileData.groom.groomMobileNo,
          groomWhatsappNo: profileData.groom.groomWhatsappNo,
          groomEmailId: profileData.groom.groomEmailId,
          groomProfile: groomProfile.label,
          groomProfileRemark: profileData.groom.groomRemarks,
          groomFbLink: profileData.groom.groomFbLink,
          groomInstLink: profileData.groom.groomInstaLink,
          groomAttachments: uploadGroomInput
        },
      }
      // const validateErrors = validate(profileObject)
      // if (Object.keys(validateErrors).length && profileObject.bride.brideEmailId) {
      //   return setFormErrors(validateErrors)
      // }
      specificDispatch(clientAction.createRecord(profileObject))
      setClientInputErrors(false)
      setTimeout(() => {
        specificDispatch(clientAction.loadRecordClientDetails(id))
      }, 2000)
      setOpenModal(!openModal)
    }
  }
  console.log(record_client_profile, "recordssd")
  //Client Data Table
  const clientData = get(record_client_details[0], "clientDetails", "")
  const [brideGroomImage, setBrideGroomAttachment] = useState([])
  useEffect(() => {
    const brideGroomImages = !isEmpty(record_client_profile) &&
      !isEmpty(record_client_profile.leadDetails) ?
      record_client_profile.leadDetails.filter(m => m.leadId == id && m.leadType == "wedding" && m.bride_groom_attachMents != undefined
      ) : []

    const images = !isEmpty(brideGroomImages) && brideGroomImages != undefined ?
      brideGroomImages.map(m => m.bride_groom_attachMents).flat() : []

    setBrideGroomAttachment(images)
  }, [id, record_client_profile])


  var slNovalue = 0
  const clientDataTable = !isEmpty(clientData)
    ? clientData.map((client, index) => {
      //Bride details
      const statusUpdate = get(client, "status", "no status")
      const profileId = get(client, "_id", "no id")
      const brideName = get(client.bride, "brideName", "No Name")
      const brideMobile = get(client.bride, "brideMobileNo", "No mobile")
      const brideWhatsapp = get(
        client.bride,
        "brideWhatsappNo",
        "No WhatsApp"
      )
      const brideEmail = get(client.bride, "brideEmailId", "No Email")
      const brideProfiles = get(client.bride, "brideProfile", "No Profile")
      const brideProfileRemarks = get(
        client.bride,
        "brideProfileRemark",
        "No Profile"
      )
      // Groom details
      const groomName = get(client.groom, "groomName", "No Name")
      const groomMobile = get(client.groom, "groomMobileNo", "No mobile")
      const groomWhatsapp = get(
        client.groom,
        "groomWhatsappNo",
        "No WhatsApp"
      )
      const groomEmail = get(client.groom, "groomEmailId", "No Email")
      const groomProfiles = get(client.groom, "groomProfile", "No Profile")
      const groomProfileRemarks = get(
        client.groom,
        "groomProfileRemark",
        "No Profile"
      )
      const groomInstLink = get(client.groom, "groomInstLink", "No Link")
      const groomFbLink = get(client.groom, "groomFbLink", "No Link")
      const brideInstLink = get(client.bride, "brideInstLink", "No Link")
      const brideFbLink = get(client.bride, "brideFbLink", "No Link")

      const groomAttachment = get(client.groom, "groomAttachments", [])
      const brideAttachment = get(client.bride, "brideAttachments", [])
      if (statusUpdate == 1) {
        slNovalue = slNovalue + 1
        return {
          _id: profileId,
          status: statusUpdate,
          sNo: slNovalue,
          brideName: brideName,
          brideMobileNo: brideMobile,
          brideWhatsappNo: brideWhatsapp,
          brideEmailId: brideEmail,
          brideProfile: brideProfiles,
          brideRemarks: brideProfileRemarks,
          groomName: groomName,
          groomMobileNo: groomMobile,
          groomWhatsappNo: groomWhatsapp,
          groomEmailId: groomEmail,
          groomProfile: groomProfiles,
          groomRemarks: groomProfileRemarks,
          groomInstLink: groomInstLink,
          groomFbLink: groomFbLink,
          brideInstLink: brideInstLink,
          brideFbLink: brideFbLink,
          groomAttachment: groomAttachment,
          brideAttachment: brideAttachment,
          key: index,
        }
      } else {
        return { _id: "" }
      }
    })
    : []

  useEffect(() => {
    if (clientUpdate.error) {
      toast.error(clientUpdate.error, {
        onClose: () => specificDispatch(clientAction.loadRecordsCacheHit()),
      })
    } else if (clientUpdate.success) {
      toast.success(clientUpdate.success, {
        onClose: () => specificDispatch(clientAction.loadRecordsCacheHit()),
      })
    }
  }, [clientUpdate.success, clientUpdate.error])

  // Edit screen
  const editClientDetails = (client) => {
    window.scrollTo(0, 1000)

    setBrideProfile({ value: client.brideProfile, label: client.brideProfile })
    setGroomProfile({ value: client.groomProfile, label: client.groomProfile })
    setProfileData({
      ...profileData,
      status: 1,
      leadId: profileData.leadId,
      leadClientDetailsId: client._id,
      type: "couple",
      bride: {
        brideName: client.brideName,
        brideMobileNo: client.brideMobileNo,
        brideWhatsappNo: client.brideWhatsappNo,
        brideEmailId: client.brideEmailId,
        brideProfile: [
          { value: client.brideProfile, label: client.brideProfile },
        ],
        brideRemarks: client.brideRemarks,
        brideFbLink: client.brideFbLink,
        brideInstaLink: client.brideInstLink,
      },
      groom: {
        groomName: client.groomName,
        groomMobileNo: client.groomMobileNo,
        groomWhatsappNo: client.groomWhatsappNo,
        groomEmailId: client.groomEmailId,
        groomProfile: [
          { value: client.groomProfile, label: client.groomProfile },
        ],
        groomRemarks: client.groomRemarks,
        groomFbLink: client.groomFbLink,
        groomInstaLink: client.groomInstLink,
      },
    })
    setFormData([...formData, client])
    if (!isEmpty(client.brideAttachment) || !isEmpty(client.groomAttachment)) {
      setUploadBrideInput(client.brideAttachment)
      setUploadGroomInput(client.groomAttachment)
      setFileName(client.brideAttachment.join(", "))
      setFileLength(client.brideAttachment.length)
      setFileGroomName(client.groomAttachment.join(", "))
      setFileGroomLength(client.groomAttachment.length)
    }
    setIsEdit(true)
    setOpenModal(true)
  }

  useEffect(() => {
    profileData
  }, [profileData])

  //Update

  const handleValues = (values, setSubmitting, redirect) => {
    setHandleValues(values)
    setSetSubmitting(setSubmitting)
    setRedirect(redirect)

    setFormErrors_2(validate_2(clientProfileEditForm))
    setIsSubmit_2(true)
  }

  const handleUpdate = (record, success) => {
    setOpenModal(false)

    // const record = recorded
    // const success = successed
    const profileUpdate = {
      status: 1,
      leadId: profileData.leadId,
      leadClientDetailId: profileData.leadClientDetailsId,
      type: "couple",
      bride: {
        brideName: profileData.bride.brideName,
        brideMobileNo: profileData.bride.brideMobileNo,
        brideWhatsappNo: profileData.bride.brideWhatsappNo,
        brideEmailId: profileData.bride.brideEmailId,
        brideProfile: brideProfile.label,
        brideProfileRemark: profileData.bride.brideRemarks,
        brideFbLink: profileData.bride.brideFbLink,
        brideInstLink: profileData.bride.brideInstaLink,
        brideAttachments: uploadBrideInput
      },
      groom: {
        groomName: profileData.groom.groomName,
        groomMobileNo: profileData.groom.groomMobileNo,
        groomWhatsappNo: profileData.groom.groomWhatsappNo,
        groomEmailId: profileData.groom.groomEmailId,
        groomProfile: groomProfile.label,
        groomProfileRemark: profileData.groom.groomRemarks,
        groomFbLink: profileData.groom.groomFbLink,
        groomInstLink: profileData.groom.groomInstaLink,
        groomAttachments: uploadGroomInput
      },
    }

    specificDispatch(
      clientAction.updateClientRecord(profileUpdate, record, success)
    )
    setTimeout(() => {
      specificDispatch(clientAction.loadRecordClientDetails(id))
      // setPageload(true)
    }, 2000)
  }
  const validate_2 = (values) => {
    const errors = {}

    if (values[0].primaryNumber?.length < 13) {
      errors.primaryNumber = "Enter 10 digit Mobile No"
    }

    if (values[0].whatsappNumber?.length < 13) {
      errors.whatsappNumber = "Enter 10 digit Mobile No"
    }

    return errors
  }
  const re = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/

  const validate = (values) => {
    const errors = {}

    // const re = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/

    if (!re.test(values.bride.brideEmailId)) {
      errors.brideEmailId = "Entered  a valid Email Id !"
    }

    if (!re.test(values.groom.groomEmailId)) {
      errors.groomEmailId = "Entered a valid Email Id!"
    }

    if (values.bride.brideMobileNo?.length < 12) {
      errors.brideMobileNo = "Enter a valid digits of Mobile No"
    }

    if (values.groom.groomMobileNo?.length < 12) {
      errors.groomMobileNo = "Enter a valid digits of Mobile No"
    }

    if (values.bride.brideWhatsappNo?.length < 12) {
      errors.brideWhatsappNo = "Enter a valid digits of Mobile No"
    }

    if (values.groom.groomWhatsappNo?.length < 12) {
      errors.groomWhatsappNo = "Enter a valid digits of Mobile No"
    }

    return errors
  }

  console.log(validate, "validate")

  useEffect(() => {
    if (Object.keys(formErrors_2).length === 0 && isSubmit_2) {
      var values = useHandleValues
      const setSubmitting = useSubmitting
      const redirect = useRedirect
      //onSubmit={(values) => {

      // same shape as initial values

      var primaryNumberValue = clientProfileEditForm[0].primaryNumber
      var secondaryNumberValue = clientProfileEditForm[0].secondaryNumber
      var whatsappNumberValue = clientProfileEditForm[0].whatsappNumber

      if (primaryNumberValue) {
        primaryNumberValue = primaryNumberValue.replace("+91", "")
      }
      if (secondaryNumberValue) {
        secondaryNumberValue = secondaryNumberValue.replace("+91", "")
      }
      if (whatsappNumberValue) {
        whatsappNumberValue = whatsappNumberValue.replace("+91", "")
      }

      const clientDetailsValue =
        clientProfileEditForm.length > 0 ? clientProfileEditForm[0] : ""
      console.log(clientDetailsValue)
      values = {
        clientId: !isEmpty(leadByClientDetailsId)
          ? leadByClientDetailsId
          : customerClientId,
        leadUuid: !isEmpty(leadDetailsUuid)
          ? leadDetailsUuid
          : customerLeadUuid,
        firstName: record_client_profile.firstName,
        lastName: record_client_profile.lastName,
        contact: {
          primaryMobile: {
            code: primaryNumberValue.slice(0, -10),
            number: primaryNumberValue && primaryNumberValue.substr(-10),
          },
          secondaryMobile: {
            code: secondaryNumberValue.slice(0, -10),
            number: secondaryNumberValue && primaryNumberValue.substr(-10),
          },
          whatsAppNo: {
            code: whatsappNumberValue.slice(0, -10),
            number: whatsappNumberValue && whatsappNumberValue.substr(-10),
          },
        },
        clientLocation: clientProfileEditForm[0].clientLocation,
        emailId: clientProfileEditForm[0].emailId,
        address: {
          primary: clientProfileEditForm[0].address,
          secondary: clientProfileEditForm[0].address,
        },
        city: clientProfileEditForm[0].city
          ? clientProfileEditForm[0].city.value
          : "",
        state: clientProfileEditForm[0].state
          ? clientProfileEditForm[0].state.value
          : "",
        country: clientProfileEditForm[0].country
          ? clientProfileEditForm[0].country.value
          : "",
        pincode: clientProfileEditForm[0].pincode,
        clientProfile: clientProfileEditForm[0].clientProfile
          ? clientProfileEditForm[0].clientProfile.value
          : "",
        profileRemarks: clientProfileEditForm[0].clientProfileRemark,
        dob: clientProfileEditForm[0].clientDOB,
        anniversaryDate: clientProfileEditForm[0].clientAnniversary,
        relativeProfile: clientProfileEditForm[0].clientRelativeProfile,
        panCard: clientProfileEditForm[0].panCardNumber,
        aadharCard: clientProfileEditForm[0].aadharCardNumber,
        clientOrgin: clientProfileEditForm[0].clientOrigin,
        relationshipStatus: clientProfileEditForm[0].relationshipStatus,
        socialMediaInfluencer: clientProfileEditForm[0].socialMediaInfluencer,
        clientReferral: clientProfileEditForm[0].clientReferral,
        star: "",
      }

      setShowForm(false)
      specificDispatch(
        clientAction.updateClientProfileRecord(values, setSubmitting, redirect)
      )

      setTimeout(() => {
        specificDispatch(
          clientAction.loadRecordClientProfileById({
            clientId: !isEmpty(leadByClientDetailsId)
              ? leadByClientDetailsId
              : customerClientId,
          })
        )
        // setPageload(true)
      }, "1000")
    }
  }, [formErrors_2])

  // console.log(customerClientId, "customerClientId")
  const [clientCompleteModal, setClientCompleteModal] = useState(false)
  // console.log("Errors", formErrors_2)
  const removeClientDetails = (success) => {
    specificDispatch(clientAction.deleteClientRecord(clientRemoveId, success))
    setTimeout(() => {
      specificDispatch(clientAction.loadRecordClientDetails(id))
      // setPageload(true)
    }, 2000)
    toast.success("Client details deleted successfully", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
    })
  }
  const [deleteForm, setDeleteForm] = useState(false)
  const [clientRemoveId, setClientRemoveId] = useState("")

  const handleClose = () => setDeleteForm(false)
  //State define
  const [showForm, setShowForm] = useState(false)

  // const handleShow = () => setDeleteForm(true)

  //Client Profile Name
  const [clientProfileEditForm, setClientProfileEditForm] = useState([
    {
      primaryNumber: "",
      secondaryNumber: "",
      whatsappNumber: "",
      emailId: "",
      clientLocation: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      clientProfile: "",
      clientProfileRemark: "",
      clientDOB: "",
      clientAnniversary: "",
      clientRelativeProfile: "",
      panCardNumber: "",
      aadharCardNumber: "",
      clientOrigin: "",
      relationshipStatus: "",
      socialMediaInfluencer: "",
      clientReferral: "",
    },
  ])

  function dateFormat(inputDate, format) {
    const date = new Date(inputDate)
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    format = format.replace("MM", month.toString().padStart(2, "0"))
    if (format.indexOf("yyyy") > -1) {
      format = format.replace("yyyy", year.toString())
    } else if (format.indexOf("yy") > -1) {
      format = format.replace("yy", year.toString().substr(2, 2))
    }
    format = format.replace("dd", day.toString().padStart(2, "0"))
    return format
  }

  const setShowFormOnclick = (value) => {
    setClientProfileEditForm([
      {
        primaryNumber:
          record_client_profile && record_client_profile.primaryNumber
            ? "+91" + record_client_profile.primaryNumber.number
            : "",

        secondaryNumber:
          record_client_profile && record_client_profile.secondaryNumber
            ? "+91" + record_client_profile.secondaryNumber.number
            : "",

        whatsappNumber:
          record_client_profile && record_client_profile.whatsappNumber
            ? "+91" + record_client_profile.whatsappNumber.number
            : "",

        emailId:
          record_client_profile && record_client_profile.emailId
            ? record_client_profile.emailId
            : "",
        clientLocation:
          record_client_profile && record_client_profile.clientLocation
            ? record_client_profile.clientLocation
            : "",
        address:
          record_client_profile && record_client_profile.address
            ? record_client_profile.address
            : "",

        city:
          record_client_profile && record_client_profile.city
            ? {
              value: record_client_profile.city.value,
              label: record_client_profile.city.cityName,
            }
            : "",

        state:
          record_client_profile && record_client_profile.state
            ? {
              value: record_client_profile.state.value,
              label: record_client_profile.state.stateName,
            }
            : "",

        country:
          record_client_profile && record_client_profile.country
            ? {
              value: record_client_profile.country.value,
              label: record_client_profile.country.countryName,
            }
            : "",

        pincode:
          record_client_profile && record_client_profile.pincode
            ? record_client_profile.pincode
            : "",

        clientProfile:
          record_client_profile && record_client_profile.clientProfile
            ? {
              value: record_client_profile.clientProfile.value,
              // ?
              // : "",
              label: record_client_profile.clientProfile.clientProfleName,
              // ?
              // : "",
            }
            : "",

        clientProfileRemark:
          record_client_profile && record_client_profile.clientProfileRemark
            ? record_client_profile.clientProfileRemark
            : "",

        clientDOB:
          record_client_profile && record_client_profile.clientDOB
            ? record_client_profile.clientDOB
            : "",

        clientAnniversary:
          record_client_profile && record_client_profile.clientAnniversary
            ? record_client_profile.clientAnniversary
            : "",
        clientRelativeProfile:
          record_client_profile && record_client_profile.clientRelativeProfile
            ? record_client_profile.clientRelativeProfile
            : "",
        panCardNumber:
          record_client_profile && record_client_profile.PANCardNumber
            ? record_client_profile.PANCardNumber
            : "",

        aadharCardNumber:
          record_client_profile && record_client_profile.aadharCardNumber
            ? record_client_profile.aadharCardNumber
            : "",

        clientOrigin:
          record_client_profile && record_client_profile.clientOrigin
            ? record_client_profile.clientOrigin
            : "",

        relationshipStatus:
          record_client_profile && record_client_profile.relationshipStatus
            ? record_client_profile.relationshipStatus
            : "",

        socialMediaInfluencer:
          record_client_profile && record_client_profile.socialMediaInfluencer
            ? record_client_profile.socialMediaInfluencer
            : "",

        clientReferral:
          record_client_profile && record_client_profile.clientReferral
            ? record_client_profile.clientReferral
            : "",
      },
    ])

    setShowForm(value)
  }

  const clientProfileEditFormOnchanges = (event, name) => {
    var clientProfileEditFormData = clientProfileEditForm[0]

    if (name == "primaryNumber" && event && event.length > 0) {
      clientProfileEditFormData.primaryNumber = "" + event
    } else if (name == "secondaryNumber" && event && event.length > 0) {
      clientProfileEditFormData.secondaryNumber = "" + event
    } else if (name == "whatsappNumber" && event && event.length > 0) {
      clientProfileEditFormData.whatsappNumber = "" + event
    } else if (name == "city" && event && event.value) {
      clientProfileEditFormData.city = event
    } else if (name == "state" && event && event.value) {
      clientProfileEditFormData.state = event
    } else if (name == "country" && event && event.value) {
      clientProfileEditFormData.country = event
    } else if (name == "clientProfile" && event) {
      clientProfileEditFormData.clientProfile = event
    } else if (name == "clientDOB" && event && event[0] > 0) {
      clientProfileEditFormData.clientDOB =
        "" + dateFormat(event[0], "yyyy-MM-dd")
    } else if (name == "clientAnniversary" && event && event[0] > 0) {
      clientProfileEditFormData.clientAnniversary =
        "" + dateFormat(event[0], "yyyy-MM-dd")
    } else if (event && event.target && event.target.name) {
      clientProfileEditFormData = {
        ...clientProfileEditFormData,
        [name]: "" + event.target.value,
      }
    }

    setClientProfileEditForm([clientProfileEditFormData])
  }

  const qcApproved =
    !isEmpty(leadDetails) && leadDetails.length > 0
      ? leadDetails[0].processStatus
      : []

  // console.log(qcApproved, "qcApproved")

  //Button Component section
  let buttonSchema = [
    {
      label: "Client / Events",
      color:
        activeTab === "Client / Events" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Follow-Up Details",
      color:
        activeTab === "Follow-Up Details"
          ? "btn btn-success"
          : "btn btn-warning",
    },
    {
      label: "Follow-Up History",
      color:
        activeTab === "Follow-Up History"
          ? "btn btn-success"
          : "btn btn-warning",
    },
    {
      label: "Notification",
      color:
        activeTab === "Notification" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Quotation",
      color: activeTab === "Quotation" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Quotation History",
      color:
        activeTab === "Quotation History"
          ? "btn btn-success"
          : "btn btn-warning",
    },
    {
      label: "Sales Entry",
      color:
        activeTab === "Sales Entry" ? "btn btn-success" : "btn btn-warning",
    },
  ]

  let eventButtons = [
    {
      label: "Client / Events",
      color:
        eventTab === "Client / Events" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Deliverables",
      color:
        eventTab === "Deliverables" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Service",
      color: eventTab === "Service" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "EC Followup",
      color: eventTab === "EC Followup" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Special Instruction",
      color:
        eventTab === "Special Instruction"
          ? "btn btn-success"
          : "btn btn-warning",
    },
    {
      label: "Client Check List",
      color:
        eventTab === "Client Check List"
          ? "btn btn-success"
          : "btn btn-warning",
    },
    {
      label: "Team Scheduling",
      color:
        eventTab === "Team Scheduling" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Equipment Scheduling",
      color:
        eventTab === "Equipment Scheduling"
          ? "btn btn-success"
          : "btn btn-warning",
    },
  ]
  let operationButtons = [
    {
      label: "Client / Events / SI",
      color:
        operationTab === "Client / Events / SI"
          ? "btn btn-success"
          : "btn btn-warning",
    },
    {
      label: "Deliverables",
      color:
        operationTab === "Deliverables" ? "btn btn-success" : "btn btn-warning",
    },

    {
      label: "App",
      color: operationTab === "App" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "EC",
      color: operationTab === "EC" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Follow-up",
      color:
        operationTab === "Follow-up" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Data Copy",
      color:
        operationTab === "Data Copy" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "First Set",
      color:
        operationTab === "First Set" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Second Set",
      color:
        operationTab === "Second Set" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Print",
      color: operationTab === "Print" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Dispatch",
      color:
        operationTab === "Dispatch" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Call Recording",
      color:
        operationTab === "Call Recording" ? "btn btn-success" : "btn btn-warning",
    },
    {
      label: "Review",
      color:
        operationTab === "Review" ? "btn btn-success" : "btn btn-warning",
    },
  ]
  let dataButtons = [
    {
      label: "Data Copy",
      color: dataTab === "Data Copy" ? "btn btn-success" : "btn btn-warning",
    },
  ]
  let tabs = [
    {
      id: 1,
      value: "sales",
      label: "Sales",
    },
    {
      id: 2,
      value: "eventCoordinator",
      label: "Event Coordinator",
    },
    {
      id: 3,
      value: "account",
      label: "Account",
    },
    {
      id: 4,
      value: "operations",
      label: "Operations",
    },
    {
      id: 5,
      value: "data",
      label: "Data",
    },
    {
      id: 6,
      value: "activities",
      label: "Activities",
    },
  ]
  //Formik Validation
  const SignupSchema = Yup.object().shape({
    primaryNumber: Yup.string().matches(
      /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      "sam"
    ),
  })

  const allowOrderStatus =
    record_client_profile &&
    record_client_profile.leadDetails &&
    record_client_profile.leadDetails[0].isAllowOrderStatus

  console.log(allowOrderStatus, "allowOrderStatus")

  //Non wedding Type section
  const [nonWeddingModal, setNonWeddingModal] = useState(false)
  const [nonWeddingEdit, setNonWeddingEdit] = useState(false)
  const [nonWeddingDeleteModal, setNonWeddingDeleteModal] = useState(false)
  const [nonWeddingRemoveId, setNonWeddingRemoveId] = useState("")

  const handleDeleteModal = () => setNonWeddingDeleteModal(false)
  //State maintenance
  const [nonWeddingData, setNonWeddingData] = useState({
    status: 1,
    leadId: id,
    leadNonWeddingId: "",
    type: "nonWedding",
    companyName: "",
    companyLocation: "",
    clientName: "",
    clientDesignation: "",
    clientProfile: "",
    clientProfileRemarks: "",
    phoneNumber: "+91",
    whatsappNumber: "+91",
    emailId: "",
    requirement: "",
    requirementDate: "",
    budget: "",
    quantity: "",
    requirementType: "",
  })

  const handleNonWeddingChange = (e) => {
    setNonWeddingData({
      ...nonWeddingData,

      [e.target.name]: e.target.value,
    })
  }

  const nonWeddingAddClear = () => {
    setNonWeddingModal(true)
    setNonWeddingData({
      companyName: "",
      companyLocation: "",
      clientName: "",
      clientDesignation: "",
      clientProfile: "",
      clientProfileRemarks: "",
      phoneNumber: "+91",
      whatsappNumber: "+91",
      emailId: "",
      requirement: "",
      requirementDate: "",
      budget: "",
      quantity: "",
      requirementType: "",
    })
    // setTimeout(()=>{
    // console.log(record_client_profile, "record_client_profile")
    const profileName =
      !isEmpty(record_client_profile) && record_client_profile.clientProfile
        ? record_client_profile.clientProfile.clientProfleName
        : ""
    // console.log(profileName, "profileName")
    const profileValue =
      !isEmpty(record_client_profile) && record_client_profile.clientProfile
        ? record_client_profile.clientProfile.value
        : ""
    // console.log(profileValue, "profileValue")

    setNonWeddingProfile({ label: profileName, value: profileValue })
    // }, 2000)
    setNonWeddingEdit(false)
  }

  const [inputErrors, setInputErrors] = useState(false)

  //List data table
  var slNo = 0
  const clientNonWeddingTable = !isEmpty(clientData)
    ? clientData.map((client, index) => {
      //Bride details
      const statusUpdate = get(client, "status", "no status")
      const profileId = get(client, "_id", "no id")
      const companyName = get(client.client, "companyName", "--")
      const companyLocation = get(client.client, "companyLocation", "--")
      const clientName = get(client.client, "clientName", "--")
      const clientDesignation = get(client.client, "clientDesignation", "--")
      const clientProfile = get(client.client, "clientProfile", "--")
      const clientProfileName = get(client.client, "clientProfileName", "--")
      const clientProfileRemarks = get(
        client.client,
        "clientProfileRemark",
        "--"
      )

      const phoneNumber = get(client.client, "clientMobileNo", "--")
      const whatsappNumber = get(client.client, "clientWhatsappNo", "--")

      const emailId = get(client.client, "clientEmailId", "--")
      const requirement = get(client.client, "requirement", "--")
      const requirementDate = get(client.client, "requirementDate", "--")

      const budget = get(client.client, "budjet", "--")
      const quantity = get(client.client, "quantity", "--")
      const requirementType = get(client.client, "requirementType", "--")

      if (statusUpdate == 1 && client.type == "single") {
        slNo = slNo + 1
        return {
          _id: profileId,
          status: statusUpdate,
          clientData: client.client,
          sNo: slNo,
          companyName: companyName,
          companyLocation: companyLocation,
          clientName: clientName,
          clientDesignation: clientDesignation,
          clientProfile: clientProfile,
          clientProfileName: clientProfileName,
          clientProfileRemarks: clientProfileRemarks,
          phoneNumber: phoneNumber,
          whatsappNumber: whatsappNumber,
          emailId: emailId,
          requirement: requirement,
          requirementDate: requirementDate,
          budget: budget,
          quantity: quantity,
          requirementType: requirementType,
          key: index,
        }
      }
    })
    : []

  const clientNonWeddingDataTable =
    !isEmpty(clientNonWeddingTable) && clientNonWeddingTable.length > 0
      ? clientNonWeddingTable.filter((data) => data != undefined)
      : ""

  //Add Non wedding client form
  const addNonWeddingClientDetails = (e) => {
    e.preventDefault()
    if (
      nonWeddingData.phoneNumber.length < 13 ||
      nonWeddingData.whatsappNumber.length < 13
    ) {
      setInputErrors(true)
      setNonWeddingModal(true)
    } else {
      const profileObject = {
        leadId: id,
        type: "single",
        client: {
          companyName: nonWeddingData.clientName,
          companyLocation: nonWeddingData.companyLocation,
          clientDesignation: nonWeddingData.clientDesignation,
          clientName: nonWeddingData.clientName,
          clientMobileNo: nonWeddingData.phoneNumber,
          clientWhatsappNo: nonWeddingData.whatsappNumber,
          clientEmailId: nonWeddingData.emailId,
          clientProfile: nonWeddingProfile.value,
          clientProfileRemark: nonWeddingData.clientProfileRemarks,
          requirement: nonWeddingData.requirement,
          requirementDate: nonWeddingData.requirementDate,
          requirementType: nonWeddingData.requirementType,
          budjet: nonWeddingData.budget,
          quantity: nonWeddingData.quantity,
        },
      }
      // console.log(profileObject, "profileObject")
      specificDispatch(clientAction.createRecord(profileObject))
      setInputErrors(false)
      setTimeout(() => {
        specificDispatch(clientAction.loadRecordClientDetails(id))
        // toast.success("Records Submitted Successfully", {
        //   position: toast.POSITION.TOP_RIGHT,
        //   autoClose: 1000,
        // })
        setNonWeddingModal(false)
      }, 2000)
    }
  }

  // Edit screen
  const editNonWeddingDetails = (client) => {
    // console.log(client, "edit non wedding")
    window.scrollTo(0, 1000)
    const requirementDate =
      !isEmpty(client) && client.requirementDate
        ? moment(client.requirementDate).format("YYYY-MM-DD")
        : "--"
    // setBrideProfile({ value: client.brideProfile, label: client.brideProfile })
    // setGroomProfile({ value: client.groomProfile, label: client.groomProfile })
    console.log(requirementDate, "requirementDate")
    setNonWeddingData({
      ...nonWeddingData,
      status: 1,
      leadNonWeddingId: client._id,
      leadId: nonWeddingData.leadId,
      leadClientDetailsId: client._id,
      companyName: client.companyName,
      companyLocation: client.companyLocation,
      clientDesignation: client.clientDesignation,
      clientName: client.clientName,
      phoneNumber: client.phoneNumber,
      whatsappNumber: client.whatsappNumber,
      emailId: client.emailId,
      clientProfile: client.clientProfile,
      clientProfileRemarks: client.clientProfileRemarks,
      requirement: client.requirement,
      requirementDate: requirementDate,
      requirementType: client.requirementType,
      budget: client.budget,
      quantity: client.quantity,
    })
    // setFormData([...formData, client])

    setNonWeddingProfile({
      label: client.clientProfileName,
      value: client.clientProfile,
    })
    setNonWeddingEdit(true)
    setNonWeddingModal(true)
  }

  //Update Non wedding form
  const handleNonWeddingUpdate = (e) => {
    e.preventDefault()
    if (
      nonWeddingData.phoneNumber.length < 13 ||
      nonWeddingData.whatsappNumber.length < 13
    ) {
      setInputErrors(true)
      setNonWeddingModal(true)
    } else {
      const profileUpdate = {
        leadId: id,
        type: "single",
        leadClientDetailId: nonWeddingData.leadNonWeddingId,
        client: {
          companyName: nonWeddingData.clientName,
          companyLocation: nonWeddingData.companyLocation,
          clientDesignation: nonWeddingData.clientDesignation,
          clientName: nonWeddingData.clientName,
          clientMobileNo: nonWeddingData.phoneNumber,
          clientWhatsappNo: nonWeddingData.whatsappNumber,
          clientEmailId: nonWeddingData.emailId,
          clientProfile: nonWeddingProfile.value,
          clientProfileRemark: nonWeddingData.clientProfileRemarks,
          requirement: nonWeddingData.requirement,
          requirementDate: nonWeddingData.requirementDate,
          requirementType: nonWeddingData.requirementType,
          budjet: nonWeddingData.budget,
          quantity: nonWeddingData.quantity,
        },
      }
      // console.log(profileUpdate, "profileUpdate")

      setInputErrors(false)

      specificDispatch(clientAction.updateClientRecord(profileUpdate))
      setTimeout(() => {
        specificDispatch(clientAction.loadRecordClientDetails(id))
        setNonWeddingModal(false)
        // toast.success("Records Updated Successfully", {
        //   position: toast.POSITION.TOP_RIGHT,
        //   autoClose: 1000,
        // })
      }, 2000)
    }
  }

  //Delete Non Wedding form

  const removeNonWeddingClient = (success) => {
    specificDispatch(
      clientAction.deleteClientRecord(nonWeddingRemoveId, success)
    )
    setTimeout(() => {
      specificDispatch(clientAction.loadRecordClientDetails(id))
      // setPageload(true)
      toast.success("Client details deleted successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 2000)
  }

  // console.log(clientNonWeddingDataTable, "clientNonWeddingDataTable")

  // const [nonWeddingProfile, setNonWeddingProfile] = useState([])
  // const [groomProfile, setGroomProfile] = useState([])
  const clientLeadId = !isEmpty(record_client_profile)
    ? record_client_profile.leadDetails.filter((data) => data.leadId === id)
    : []
  const updateClientCompleteLeadId = !isEmpty(clientLeadId)
    ? clientLeadId.map((m) => m.leadId).join()
    : id

  var recordsValue = clientUpdate.records
  const recordsValueArray = recordsValue.filter((record) => record._id === id)
  const clientCompleteClientId = !isEmpty(recordsValueArray)
    ? recordsValueArray.map((m) => m.clientId).join()
    : ""
  const clientPayload = {
    mode: "Operations",
    clientId: clientCompleteClientId,
  }
  const updateClientComplete = () => {
    const client_complete = {
      leadId: updateClientCompleteLeadId,
    }
    // console.log(client_complete)
    dispatch(clientAction.addClientComplete(client_complete))
    setTimeout(() => {
      dispatch(clientAction.loadRecordClientProfileById(clientPayload))
      toast.success("Client Complete updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 2000)
    setClientCompleteModal(false)
  }
  //only engagement
  const [onlyEngagement, setOnlyEngagement] = useState("")
  const [mainEvent, setMainEvent] = useState([])
  const engageRemove = !isEmpty(leadDetails) &&
    leadDetails[0].onlyEngagement
    ? leadDetails[0].onlyEngagement : false
  const onlyEngagementStatus = !isEmpty(leadDetails) &&
    leadDetails[0].onlyEngagementStatus
    ? leadDetails[0].onlyEngagementStatus : ""
    const engageValue = onlyEngagementStatus =="mainEventBooked"?"Main Event Booked":
    onlyEngagementStatus =="mainEventNotBooked"?"Main Event Not Booked":""
  useEffect(() => {
    setOnlyEngagement(engageRemove)
    if(onlyEngagementStatus){
      setMainEvent({ label: engageValue, value: onlyEngagementStatus })
    }
  
  }, [leadDetails])
  const [onlyEngagementModal, setOnlyEngagementModal] = useState(false)
  const statusList = [
    {
      label: "Only Engagement",
      value: true,
    },
  ]

  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setOnlyEngagement(value)
      setOnlyEngagementModal(value)
    } else {
      setOnlyEngagement(false)
      setOnlyEngagementModal(true)
    setMainEvent([])
    }
  }
  const updateEngagement = () => {
 //   if (simpleEngageValidator.current.allValid()) {
      const payload = {
        "leadId": id,
        "onlyEngagement": onlyEngagement,
        "onlyEngagementStatus": mainEvent.value
      }
      console.log(payload)

      setOnlyEngagementModal(false)
      dispatch(clientAction.updateEngagement(payload))
      setTimeout(() => {
        dispatch(clientAction.loadRecordClientProfileById({
          mode: "SALES",
          clientId: leadByClientDetailsId,
        }))
        toast.success("Only Engagement Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })

      }, 1000)
    // } else {
    //   simpleEngageValidator.current.showMessages()
    //   forceUpdated(1)
    //   setOnlyEngagementModal(true)
    // }
  }
  //good looking client
  const [goodLookingClient, setGoodLookingClient] = useState("")

  const goodClientRemove = !isEmpty(leadDetails) &&
    leadDetails[0].goodLookingClient
    ? leadDetails[0].goodLookingClient : false
  useEffect(() => {
    setGoodLookingClient(goodClientRemove)
  }, [leadDetails])
  const [goodLookingClientModal, setGoodLookingClientModal] = useState(false)
  const goodCLientList = [
    {
      label: "Good Looking CLient",
      value: true,
    },
  ]

  const handleGoodChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setGoodLookingClient(value)
      setGoodLookingClientModal(value)
    } else {
      setGoodLookingClient(false)
      setGoodLookingClientModal(true)
    }
  }

  //High End CLient

  const [highEndClient, setHighEndClient] = useState("")

  const highEndClientRemove = !isEmpty(leadDetails) &&
    leadDetails[0].highEndClient
    ? leadDetails[0].goodLookingClient : false
  useEffect(() => {
    setHighEndClient(highEndClientRemove)
  }, [leadDetails])
  const [highEndClientModal, setHighEndClientModal] = useState(false)
  const highEndClientList = [
    {
      label: "High End CLient",
      value: true,
    },
  ]

  const highEndClientChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setHighEndClient(value)
      setHighEndClientModal(value)
    } else {
      setHighEndClient(false)
      setHighEndClientModal(true)
    }
  }

  //update good an dgigh end client
  const updateHighEnd = () => {
    let payload = {
      "leadId": id,
      highEndClient: highEndClient
    }

    setHighEndClientModal(false)
    dispatch(clientAction.updateHighGood(payload))
    setTimeout(() => {
      dispatch(clientAction.loadRecordClientProfileById({
        mode: "SALES",
        clientId: leadByClientDetailsId,
      }))
      toast.success("High End Client Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)

  }
  //update good an dgigh end client
  const updateGoodLook = () => {
    let payload = {
      "leadId": id,
      goodLookingClient: goodLookingClient
    }

    setGoodLookingClientModal(false)
    dispatch(clientAction.updateHighGood(payload))
    setTimeout(() => {
      dispatch(clientAction.loadRecordClientProfileById({
        mode: "SALES",
        clientId: leadByClientDetailsId,
      }))
      toast.success("Good Looking Client Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)

  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{"Client Details"} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Card>
            <CardBody>
              <Row>
                <Col md={3} style={{ padding: "16px" }}>
                  <Row
                    style={{
                      flexDirection: "column",
                      border: "2px solid #E5E5E5",
                      borderRadius: "4px",
                    }}
                  >
                    <Col
                      style={{
                        backgroundColor: "#E40D8C",
                        color: "white",
                        minHeight: "65px",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "16px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                      }}
                    >
                      {record_client_profile &&
                        record_client_profile.clientNumber
                        ? record_client_profile.clientNumber
                        : "--"}{" "}
                      -{" "}
                      {record_client_profile && record_client_profile.fullName
                        ? record_client_profile.fullName
                        : "--"}
                    </Col>
                    {/* groom and bride attachment show */}
                    {!isEmpty(brideGroomImage) ? (
                      <div
                        style={{
                          padding: "10px",
                          height: "180px",
                          overflowY: "scroll",
                          marginBottom: "25px"
                        }}
                      >
                        {brideGroomImage.map((image, index) => (
                          <a
                            key={index}
                            onClick={() => window.open(image, "_blank")}
                            style={{
                              display: "block",
                              marginBottom: "10px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={image}
                              alt={`Bride/Groom ${index + 1}`}
                              style={{
                                width: "320px",
                                height: "180px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          </a>
                        ))}
                      </div>
                    ) : (
                      ""
                    )}
                    {showForm ? null : (
                      <Col
                        style={{
                          display: "flex",
                          alignItems: "center",
                          paddingTop: "15px",
                          // paddingBottom: "15px",
                          marginBottom: "5px",
                          borderBottom: "1px solid rgb(229, 229, 229)",
                        }}
                      >
                        <>
                          <Row className="client-details-edit-button">
                            <Col>
                              <p
                                style={{
                                  color: "#9ABDF3",
                                  marginTop: "2px",
                                  marginRight: "4px",
                                  fontSize: "14px",
                                  width: "max-content",
                                }}
                              >
                                Client Details
                              </p>
                            </Col>
                            {moduleMode === "EC" || moduleMode == "Data" ? (
                              ""
                            ) : (
                              <Col
                                md="4"
                                style={{
                                  color: "#34C28F",
                                  border: "1px solid #34C28F",
                                  borderRadius: "4px",
                                  padding: "6px",
                                  width: "70px",
                                  height: "30px",
                                  margin: "0 10px",
                                  marginBottom: "10px",
                                  // textAlign: 'center',
                                  cursor: "pointer",
                                }}
                                onClick={() => setShowFormOnclick(!showForm)}
                                className="pointer"
                              >
                                <i className="fas fa-edit"></i> Edit
                              </Col>
                            )}
                          </Row>
                        </>
                      </Col>
                    )}

                    {showForm ? (
                      <Col
                        style={{
                          marginBottom: "25px",
                        }}
                      >
                        <Row
                          style={{
                            flexDirection: "column",
                          }}
                        >
                          <Formik
                            initialValues={{
                              primaryNumber: "",
                              secondaryNumber: "",
                              whatsappNumber: "",
                              emailId: record_client_profile.emailId,
                              clientLocation:
                                record_client_profile.clientLocation,
                              address: record_client_profile.address,
                              city: "",
                              state: "",
                              country: "",
                              pincode: "",
                              clientProfile: "",
                              clientProfileRemark: "",
                            }}
                            validationSchema={SignupSchema}
                            onSubmit={(values, setSubmitting, redirect) =>
                              handleValues(values, setSubmitting, redirect)
                            }
                          >
                            {({ errors, touched }) => (
                              <Form>
                                {showForm ? (
                                  <Col
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      paddingTop: "15px",
                                      paddingBottom: "15px",
                                      borderBottom:
                                        "1px solid rgb(229, 229, 229)",
                                    }}
                                  >
                                    <Col>
                                      <button
                                        onClick={() => setShowForm(false)}
                                        type="button"
                                        className="btn btn-danger btn-label simple-form-cancel-btn"
                                      >
                                        <i className="bx bx-block label-icon "></i>
                                        Cancel
                                      </button>
                                      <button
                                        type="submit"
                                        className="btn btn-success btn-label simple-form-submit-btn"
                                      >
                                        <i className="bx bx-check-double label-icon"></i>
                                        Submit
                                      </button>
                                    </Col>
                                  </Col>
                                ) : null}

                                {/* Primary number  */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Primary Number"}
                                    >
                                      {"Primary Number"}{" "}
                                      <span className="required-symbol">*</span>
                                    </Label>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <PhoneInput
                                        maxlength={15}
                                        international
                                        // countryCallingCodeEditable={false}
                                        placeholder={"Enter Primary Number"}
                                        style={{ flex: "2" }}
                                        value={
                                          clientProfileEditForm[0].primaryNumber
                                        }
                                        onChange={(event) =>
                                          clientProfileEditFormOnchanges(
                                            event,
                                            "primaryNumber"
                                          )
                                        }
                                        disabled={
                                          !isEmpty(
                                            record_client_profile.primaryNumber
                                              .number
                                          ) ||
                                            record_client_profile.primaryNumber
                                              .number != null
                                            ? true
                                            : false
                                        }
                                        name="primaryNumber"
                                        id="primaryNumber"
                                      />
                                      {formErrors_2.primaryNumber !== "" ? (
                                        <p
                                          style={{
                                            color: "red",
                                            fontSize: "10px",
                                            marginLeft: "30px",
                                          }}
                                        >
                                          {formErrors_2.primaryNumber}
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    {errors.primaryNumber &&
                                      touched.primaryNumber ? (
                                      <span className="required">
                                        {errors.primaryNumber}
                                      </span>
                                    ) : null}
                                  </FormGroup>
                                </React.Fragment>

                                {/* Secondary number  */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Secondary Number"}
                                    >
                                      {"Secondary Number"}{" "}
                                      {/* <span className="required-symbol">*</span> */}
                                    </Label>
                                    <div className="d-flex flex-column">
                                      <PhoneInput
                                        maxlength={15}
                                        international
                                        countryCallingCodeEditable={false}
                                        placeholder={"Enter Secondary Number"}
                                        style={{ flex: "2" }}
                                        value={
                                          clientProfileEditForm[0]
                                            .secondaryNumber
                                        }
                                        disabled={
                                          !isEmpty(
                                            record_client_profile
                                              .secondaryNumber.number
                                          ) ||
                                            record_client_profile.secondaryNumber
                                              .number != null
                                            ? true
                                            : false
                                        }
                                        onChange={(event) =>
                                          clientProfileEditFormOnchanges(
                                            event,
                                            "secondaryNumber"
                                          )
                                        }
                                        name="secondaryNumber"
                                        id="secondaryNumber"
                                      />
                                    </div>
                                  </FormGroup>
                                </React.Fragment>

                                {/* Whatsapp number  */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Whatsapp Number"}
                                    >
                                      {"Whatsapp Number"}{" "}
                                      <span className="required-symbol">*</span>
                                    </Label>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <PhoneInput
                                        maxlength={15}
                                        international
                                        countryCallingCodeEditable={false}
                                        placeholder={"Enter Whatsapp Number"}
                                        style={{ flex: "2" }}
                                        value={
                                          clientProfileEditForm[0]
                                            .whatsappNumber
                                        }
                                        onChange={(event) =>
                                          clientProfileEditFormOnchanges(
                                            event,
                                            "whatsappNumber"
                                          )
                                        }
                                        disabled={
                                          !isEmpty(
                                            record_client_profile.whatsappNumber
                                              .number
                                          ) ||
                                            record_client_profile.whatsappNumber
                                              .number != null
                                            ? true
                                            : false
                                        }
                                        name="whatsappNumber"
                                        id="whatsappNumber"
                                      />
                                      {formErrors_2.whatsappNumber !== "" ? (
                                        <p
                                          style={{
                                            color: "red",
                                            fontSize: "10px",
                                            marginLeft: "30px",
                                          }}
                                        >
                                          {formErrors_2.whatsappNumber}
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                    {errors.whatsappNumber &&
                                      touched.whatsappNumber ? (
                                      <span className="required">
                                        {errors.whatsappNumber}
                                      </span>
                                    ) : null}
                                  </FormGroup>
                                </React.Fragment>

                                {/* Email */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Email ID"}
                                    >
                                      {"Email ID"}
                                    </Label>
                                    <Input
                                      type="email"
                                      className="form-control"
                                      name="emailId"
                                      id="emailId"
                                      disabled={
                                        !isEmpty(record_client_profile.emailId)
                                          ? true
                                          : false
                                      }
                                      placeholder={"Enter Email ID"}
                                      value={clientProfileEditForm[0].emailId}
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "emailId"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* Client Location */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Client Location"}
                                    >
                                      {"Client Location"}
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="clientLocation"
                                      id="clientLocation"
                                      // style={{ textTransform: "uppercase" }}
                                      disabled={
                                        !isEmpty(
                                          record_client_profile.clientLocation
                                        )
                                          ? true
                                          : false
                                      }
                                      value={
                                        clientProfileEditForm[0].clientLocation
                                      }
                                      placeholder={"Enter Client Location"}
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "clientLocation"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* Address */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Address"}
                                    >
                                      {"Address"}
                                    </Label>
                                    <Input
                                      type="textarea"
                                      className="form-control"
                                      name="address"
                                      id="address"
                                      disabled={
                                        !isEmpty(record_client_profile.address)
                                          ? true
                                          : false
                                      }
                                      placeholder={"Enter Address"}
                                      maxLength="225"
                                      rows="3"
                                      value={clientProfileEditForm[0].address}
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "address"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* City */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"City"}
                                    >
                                      {"City"}
                                    </Label>
                                    <Select
                                      type="text"
                                      name="city"
                                      id="city"
                                      isDisabled={
                                        !isEmpty(
                                          clientProfileEditForm[0].city.value
                                        )
                                          ? true
                                          : false
                                      }
                                      placeholder={"Enter City"}
                                      // style={{ textTransform: "uppercase" }}
                                      value={clientProfileEditForm[0].city}
                                      options={
                                        recordsMetaData
                                          ? recordsMetaData.cityOptions
                                          : []
                                      }
                                      classNamePrefix="select2-selection"
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "city"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* State */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"State"}
                                    >
                                      {"State"}
                                    </Label>
                                    <Select
                                      type="text"
                                      name="state"
                                      id="state"
                                      isDisabled={
                                        !isEmpty(
                                          clientProfileEditForm[0].state.value
                                        )
                                          ? true
                                          : false
                                      }
                                      placeholder={"Enter State"}
                                      value={clientProfileEditForm[0].state}
                                      options={
                                        recordsMetaData
                                          ? recordsMetaData.stateOptions
                                          : []
                                      }
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "state"
                                        )
                                      }
                                      classNamePrefix="select2-selection"
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* Country */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Country"}
                                    >
                                      {"Country"}
                                    </Label>
                                    <Select
                                      type="text"
                                      name="country"
                                      id="country"
                                      isDisabled={
                                        !isEmpty(
                                          clientProfileEditForm[0].country.value
                                        )
                                          ? true
                                          : false
                                      }
                                      placeholder={"Enter Country"}
                                      value={clientProfileEditForm[0].country}
                                      options={
                                        recordsMetaData
                                          ? recordsMetaData.countryOptions
                                          : []
                                      }
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "country"
                                        )
                                      }
                                      classNamePrefix="select2-selection"
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* pincode */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Pincode"}
                                    >
                                      {"Pincode"}
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="pincode"
                                      id="pincode"
                                      maxLength={6}
                                      disabled={
                                        !isEmpty(record_client_profile.pincode)
                                          ? true
                                          : false
                                      }
                                      placeholder={"Enter Pincode"}
                                      value={clientProfileEditForm[0].pincode}
                                      onChange={(e) => {
                                        const re = /^[0-9\b]+$/
                                        // console.log(e,"aadhar")

                                        if (
                                          e.target.value === "" ||
                                          re.test(e.target.value)
                                        ) {
                                          clientProfileEditFormOnchanges(
                                            e,
                                            "pincode"
                                          )
                                        }
                                      }}
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* Client Prifile */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Client Prifile"}
                                    >
                                      {"Client Profile"}
                                    </Label>
                                    <Select
                                      type="text"
                                      name="clientProfile"
                                      id="clientProfile"
                                      // style={{ textTransform: "uppercase" }}
                                      isDisabled={
                                        !isEmpty(
                                          clientProfileEditForm[0].clientProfile
                                            .value
                                        )
                                          ? true
                                          : false
                                      }
                                      placeholder={"Enter Client Profile"}
                                      value={
                                        clientProfileEditForm[0].clientProfile
                                      }
                                      options={
                                        recordsMetaData
                                          ? recordsMetaData.clientProfileOptions
                                          : []
                                      }
                                      classNamePrefix="select2-selection"
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "clientProfile"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* Client Prifile Remark */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Client Prifile Remark"}
                                    >
                                      {"Client Profile Remark"}
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="clientProfileRemark"
                                      id="clientProfileRemark"
                                      // style={{ textTransform: "uppercase" }}
                                      value={
                                        clientProfileEditForm[0]
                                          .clientProfileRemark
                                      }
                                      disabled={
                                        !isEmpty(
                                          record_client_profile.clientProfileRemark
                                        )
                                          ? true
                                          : false
                                      }
                                      placeholder={
                                        "Enter Client Profile Remark"
                                      }
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "clientProfileRemark"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* Client DOB */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Client DOB"}
                                    >
                                      {"Client DOB"}
                                    </Label>
                                    <Flatpickr
                                      className="form-control d-block"
                                      placeholder="YYYY-MM-DD"
                                      name="clientDOB"
                                      id="clientDOB"
                                      disabled={
                                        !isEmpty(
                                          record_client_profile.clientDOB
                                        )
                                          ? true
                                          : false
                                      }
                                      value={clientProfileEditForm[0].clientDOB}
                                      options={{
                                        altInput: true,
                                        altFormat: "Y-m-d",
                                        dateFormat: "Y-m-d",
                                      }}
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "clientDOB"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* Client Anniversary */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Client Anniversary"}
                                    >
                                      {"Client Anniversary"}
                                    </Label>
                                    <Flatpickr
                                      className="form-control d-block"
                                      placeholder="YYYY-MM-DD"
                                      name="clientAnniversary"
                                      id="clientAnniversary"
                                      value={
                                        clientProfileEditForm[0]
                                          .clientAnniversary
                                      }
                                      disabled={
                                        !isEmpty(
                                          record_client_profile.clientAnniversary
                                        )
                                          ? true
                                          : false
                                      }
                                      options={{
                                        altInput: true,
                                        altFormat: "Y-m-d",
                                        dateFormat: "Y-m-d",
                                      }}
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "clientAnniversary"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* Client Relative Profile */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Client Relative Profile"}
                                    >
                                      {"Client Relative Profile"}
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="clientRelativeProfile"
                                      id="clientRelativeProfile"
                                      // style={{ textTransform: "uppercase" }}
                                      value={
                                        clientProfileEditForm[0]
                                          .clientRelativeProfile
                                      }
                                      disabled={
                                        !isEmpty(
                                          record_client_profile.clientRelativeProfile
                                        )
                                          ? true
                                          : false
                                      }
                                      placeholder={
                                        "Enter Client Relative Profile"
                                      }
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "clientRelativeProfile"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* PAN Card Number */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"PAN Card Number"}
                                    >
                                      {"PAN Card Number"}
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="panCardNumber"
                                      id="panCardNumber"
                                      //  style={{textTransform:"uppercase"}}
                                      maxLength={10}
                                      disabled={
                                        !isEmpty(
                                          record_client_profile.panCardNumber
                                        )
                                          ? true
                                          : false
                                      }
                                      placeholder={"Enter PAN Card Number"}
                                      value={
                                        clientProfileEditForm[0].panCardNumber
                                      }
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "panCardNumber"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* Aadhar Card Number */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Aadhar Card Number"}
                                    >
                                      {"Aadhar Card Number"}
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="aadharCardNumber"
                                      id="aadharCardNumber"
                                      maxLength={12}
                                      disabled={
                                        !isEmpty(
                                          record_client_profile.aadharCardNumber
                                        )
                                          ? true
                                          : false
                                      }
                                      placeholder={"Enter Aadhar Card Number"}
                                      value={
                                        clientProfileEditForm[0]
                                          .aadharCardNumber
                                      }
                                      onChange={(e) => {
                                        const re = /^[0-9\b]+$/
                                        // console.log(e,"aadhar")
                                        if (
                                          e.target.value === "" ||
                                          re.test(e.target.value)
                                        ) {
                                          clientProfileEditFormOnchanges(
                                            e,
                                            "aadharCardNumber"
                                          )
                                        }
                                      }}
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* clientOrigin */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Client Origin"}
                                    >
                                      {"Client Origin"}
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="clientOrigin"
                                      id="clientOrigin"
                                      // style={{ textTransform: "uppercase" }}
                                      disabled={
                                        !isEmpty(
                                          record_client_profile.clientOrigin
                                        )
                                          ? true
                                          : false
                                      }
                                      value={
                                        clientProfileEditForm[0].clientOrigin
                                      }
                                      placeholder={"Enter Client Origin"}
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "clientOrigin"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* clientOrigin */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Relationship Status"}
                                    >
                                      {"Relationship Status"}
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="relationshipStatus"
                                      id="relationshipStatus"
                                      disabled={
                                        !isEmpty(
                                          record_client_profile.relationshipStatus
                                        )
                                          ? true
                                          : false
                                      }
                                      value={
                                        clientProfileEditForm[0]
                                          .relationshipStatus
                                      }
                                      placeholder={"Enter Relationship Status"}
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "relationshipStatus"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* Social Media Influencer */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Social Media Influencer"}
                                    >
                                      {"Social Media Influencer"}
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="socialMediaInfluencer"
                                      id="socialMediaInfluencer"
                                      disabled={
                                        !isEmpty(
                                          record_client_profile.socialMediaInfluencer
                                        )
                                          ? true
                                          : false
                                      }
                                      value={
                                        clientProfileEditForm[0]
                                          .socialMediaInfluencer
                                      }
                                      placeholder={
                                        "Enter Social Media Influencer"
                                      }
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "socialMediaInfluencer"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* Client Referral */}
                                <React.Fragment>
                                  <FormGroup>
                                    <Label
                                      className={"form-label"}
                                      htmlFor={"Client Referral"}
                                    >
                                      {"Client Referral"}
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      name="clientReferral"
                                      id="clientReferral"
                                      disabled={
                                        !isEmpty(
                                          record_client_profile.clientReferral
                                        )
                                          ? true
                                          : false
                                      }
                                      value={
                                        clientProfileEditForm[0].clientReferral
                                      }
                                      placeholder={"Enter Client Referral"}
                                      onChange={(event) =>
                                        clientProfileEditFormOnchanges(
                                          event,
                                          "clientReferral"
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </React.Fragment>

                                {/* Submit */}
                                <React.Fragment>
                                  <Col
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      paddingTop: "15px",
                                      paddingBottom: "15px",
                                      borderBottom:
                                        "1px solid rgb(229, 229, 229)",
                                    }}
                                  >
                                    <Col>
                                      <button
                                        onClick={() => setShowForm(false)}
                                        type="button"
                                        className="btn btn-danger btn-label simple-form-cancel-btn"
                                      >
                                        <i className="bx bx-block label-icon "></i>
                                        Cancel
                                      </button>
                                      <button
                                        type="submit"
                                        className="btn btn-success btn-label simple-form-submit-btn"
                                      >
                                        <i className="bx bx-check-double label-icon"></i>
                                        Submit
                                      </button>
                                    </Col>
                                  </Col>
                                </React.Fragment>
                              </Form>
                            )}
                          </Formik>
                        </Row>
                      </Col>
                    ) : (
                      <Col style={{ marginTop: "25px" }}>
                        <Row
                          style={{
                            flexDirection: "column",
                          }}
                        >
                          <>
                            <Row
                              lg="12"
                              md="12"
                              sm="12"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="5" xl="5" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Primary Number"} :
                                </p>
                              </Col>
                              <Col lg="7" xl="7" md="12">
                                <p className="client-detail-grid-value">
                                  {record_client_profile &&
                                    record_client_profile.primaryNumber &&
                                    record_client_profile.primaryNumber.code
                                    ? record_client_profile.primaryNumber.code
                                    : ""}{" "}
                                  {record_client_profile &&
                                    record_client_profile.primaryNumber &&
                                    record_client_profile.primaryNumber.number
                                    ? record_client_profile.primaryNumber.number
                                    : "--"}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              lg="12"
                              md="12"
                              sm="12"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="5" xl="5" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Secondary Number"} :
                                </p>
                              </Col>
                              <Col lg="7" xl="7" md="12">
                                <p className="client-detail-grid-value">
                                  {record_client_profile &&
                                    record_client_profile.secondaryNumber &&
                                    record_client_profile.secondaryNumber.code
                                    ? record_client_profile.secondaryNumber.code
                                    : ""}{" "}
                                  {record_client_profile &&
                                    record_client_profile.secondaryNumber &&
                                    record_client_profile.secondaryNumber.number
                                    ? record_client_profile.secondaryNumber
                                      .number
                                    : "--"}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              lg="12"
                              md="12"
                              sm="12"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="5" xl="5" md="7">
                                <p className="client-detail-grid-heading">
                                  {"Whatsapp Number"} :
                                </p>
                              </Col>
                              <Col lg="7" xl="7" md="7">
                                <p className="client-detail-grid-value">
                                  {record_client_profile &&
                                    record_client_profile.whatsappNumber &&
                                    record_client_profile.whatsappNumber.code
                                    ? record_client_profile.whatsappNumber.code
                                    : ""}{" "}
                                  {record_client_profile &&
                                    record_client_profile.whatsappNumber &&
                                    record_client_profile.whatsappNumber.number
                                    ? record_client_profile.whatsappNumber
                                      .number
                                    : "--"}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="6" sm="12">
                                <p className="client-detail-grid-heading">
                                  {"Email ID"} :
                                </p>
                              </Col>
                              <Col lg="6" xl="6" md="6" sm="12">
                                <p className="client-detail-grid-value">
                                  {" "}
                                  {record_client_profile &&
                                    record_client_profile.emailId
                                    ? record_client_profile.emailId
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Client Location"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p className="client-detail-grid-value">
                                  {record_client_profile &&
                                    record_client_profile.clientLocation
                                    ? record_client_profile.clientLocation
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Address"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p className="client-detail-grid-value">
                                  {record_client_profile &&
                                    record_client_profile.address
                                    ? record_client_profile.address
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"City"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p className="client-detail-grid-value">
                                  {record_client_profile &&
                                    record_client_profile.city &&
                                    record_client_profile.city.cityName
                                    ? record_client_profile.city.cityName
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"State"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p className="client-detail-grid-value">
                                  {record_client_profile &&
                                    record_client_profile.state &&
                                    record_client_profile.state.stateName
                                    ? record_client_profile.state.stateName
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Country"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p className="client-detail-grid-value">
                                  {record_client_profile &&
                                    record_client_profile.country &&
                                    record_client_profile.country.countryName
                                    ? record_client_profile.country.countryName
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Pincode"} :
                                </p>
                              </Col>
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-value">
                                  {record_client_profile &&
                                    record_client_profile.pincode
                                    ? record_client_profile.pincode
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Client Profile"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p className="client-detail-grid-value">
                                  {record_client_profile &&
                                    record_client_profile.clientProfile &&
                                    record_client_profile.clientProfile
                                      .clientProfleName
                                    ? record_client_profile.clientProfile
                                      .clientProfleName
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Client Profile Remark"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p className="client-detail-grid-value">
                                  {record_client_profile &&
                                    record_client_profile.clientProfileRemark
                                    ? record_client_profile.clientProfileRemark
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Client DOB"} :
                                </p>
                              </Col>
                              <Col lg="6" xl="6" md="12">
                                <p>
                                  {record_client_profile &&
                                    record_client_profile.clientDOB
                                    ? moment(
                                      record_client_profile.clientDOB
                                    ).format(dateFormate)
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Client Anniversary"} :
                                </p>
                              </Col>
                              <Col lg="6" xl="6" md="12">
                                <p>
                                  {record_client_profile &&
                                    record_client_profile.clientAnniversary
                                    ? moment(
                                      record_client_profile.clientAnniversary
                                    ).format(dateFormate)
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Client Relative Profile"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p>
                                  {record_client_profile &&
                                    record_client_profile.clientRelativeProfile
                                    ? record_client_profile.clientRelativeProfile
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"PAN Card Number"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p>
                                  {record_client_profile &&
                                    record_client_profile.PANCardNumber
                                    ? record_client_profile.PANCardNumber
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Aadhar Card Number"} :
                                </p>
                              </Col>
                              <Col lg="6" xl="6" md="12">
                                <p>
                                  {record_client_profile &&
                                    record_client_profile.aadharCardNumber
                                    ? record_client_profile.aadharCardNumber
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Client Origin"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p>
                                  {record_client_profile &&
                                    record_client_profile.clientOrigin
                                    ? record_client_profile.clientOrigin
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Relationship Status"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p>
                                  {record_client_profile &&
                                    record_client_profile.relationshipStatus
                                    ? record_client_profile.relationshipStatus
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Social Media Influencer"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p>
                                  {record_client_profile &&
                                    record_client_profile.socialMediaInfluencer
                                    ? record_client_profile.socialMediaInfluencer
                                    : ""}
                                </p>
                              </Col>
                            </Row>

                            <Row
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col lg="6" xl="6" md="12">
                                <p className="client-detail-grid-heading">
                                  {"Client Referral"} :
                                </p>
                              </Col>
                              <Col
                                lg="6"
                                xl="6"
                                md="12"
                                style={{ textTransform: "uppercase" }}
                              >
                                <p>
                                  {record_client_profile &&
                                    record_client_profile.clientReferral
                                    ? record_client_profile.clientReferral
                                    : ""}
                                </p>
                              </Col>
                            </Row>
                          </>
                        </Row>
                      </Col>
                    )}
                  </Row>
                  {/* Questions list */}
                  <Col lg="12" md="12" xl="12" sm="12" xs="12">
                    <ClientQuestionsList
                      clientId={
                        !isEmpty(leadByClientDetailsId)
                          ? leadByClientDetailsId
                          : customerClientId
                      }
                      moduleMode={moduleModeData}
                    />
                  </Col>
                </Col>

                {/* Client details end */}
                {/* EC process status colors section */}
                <Col
                  md={9}
                  style={{ padding: "16px", height: "100%" }}
                  className="d-flex flex-column mb-2"
                >
                  {moduleMode === "EC" ? (
                    <Row
                      className="d-flex flex-column"
                      style={{ alignSelf: "flex-end", marginTop: "-21px" }}
                    >
                      <Col
                        className="d-flex flex-row"
                        style={{ alignSelf: "flex-end" }}
                      >
                        <div className="d-flex flex-row">
                          <div className="before-initiative-ec"></div>
                          <h6 className="ec-process-label">
                            Before Initiative
                          </h6>
                        </div>
                        <div className="d-flex flex-row">
                          <div className="processing-ec"></div>
                          <h6 className="ec-process-label">Processing</h6>
                        </div>

                        <div className="d-flex flex-row">
                          <div className="completed-ec"></div>
                          <h6 className="ec-process-label">Completed</h6>
                        </div>
                        <div className="d-flex flex-row">
                          <div className="operation-end-ec"></div>
                          <h6 className="ec-process-label">Operation End</h6>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  <Row
                    style={{
                      flexDirection: "column",
                      border: "2px solid #E5E5E5",
                      borderRadius: "4px",
                    }}
                  >
                    <Col
                      style={{
                        backgroundColor: "#E40D8C",
                        color: "white",
                        minHeight: "65px",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "18px",
                      }}
                    >
                      {moduleMode === "SALES" ? (
                        <div>
                          <button
                            style={{
                              background: "#34c38f",
                              border: "none",
                              cursor: "pointer",
                              color: "white",
                              padding: "6px 8px",
                              marginRight: "10px",
                              borderRadius: "3px",
                              fontSize: "13px",
                            }}
                            onClick={() => setNewLeadModal(true)}
                          >
                            Add New Lead
                          </button>
                        </div>
                      ) : (
                        ""
                      )}
                      {!isEmpty(record_client_profile) &&
                        !isEmpty(leadDetails) &&
                        leadDetails.map((data, key) => {
                          // console.log(data.leadId, "data id")
                          return (
                            <div
                              key={key}
                              style={{
                                // backgroundColor:
                                //   data.leadId === id ? "#d1cfcf" : "white",
                                backgroundColor: "#fffffff7",
                                color:
                                  data.processStatus === "PS9"
                                    ? "#17d304"
                                    : "black",
                                fontWeight: "bold",
                                fontSize: "18px",
                                padding: "6px",
                                borderRadius: "4px",
                                minWidth: "150px",
                                textAlign: "center",
                                marginRight: "10px",
                                cursor: "pointer",
                                textTransform: "uppercase",
                                opacity: data.leadId === id ? 0.9 : "",
                                pointerEvents: data.leadId === id ? "none" : "",
                              }}
                              onClick={() => {
                                setLoading(true)
                                setMultipleLeadId(data.leadId)
                                setEventDataLoading(true)
                                setEventCoordinatorLoading(true)
                                setModuleMode(moduleMode)
                                setTimeout(() => {
                                  history.push(`/client-details/${data.leadId}`)
                                  setLoading(false)
                                }, 3000)
                                setTimeout(() => {
                                  // history.push(
                                  //   `/client-details/${data.leadId}`
                                  // )
                                  // setMultipleLeadId(data.leadId)
                                  setEventDataLoading(false)
                                  setEventCoordinatorLoading(false)
                                }, 6000)
                              }}
                            >
                              {data && data.leadNumber ? data.leadNumber : "--"}
                            </div>
                          )
                        })}
                      {!isEmpty(record_client_profile) &&
                        !isEmpty(multipleLeadDetails) &&
                        multipleLeadDetails.length > 0
                        ? multipleLeadDetails.filter(m => leadDetails.some(l => l.companyId === m.companyId))
                          .map((data, key) => {
                            console.log(data, "dataid")
                            return (
                              <div
                                key={key}
                                style={{
                                  backgroundColor: "white",
                                  // backgroundColor:
                                  //   data.leadId === id ? "#d1cfcf" : "white",
                                  color: "black",
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                  padding: "6px",
                                  borderRadius: "4px",
                                  minWidth: "150px",
                                  textAlign: "center",
                                  marginRight: "10px",
                                  boxShadow: "2px 4px 6px #6f5c5c",
                                  opacity: data.leadId === id ? 0.5 : "",
                                  // pointer-events: none;
                                  pointerEvents:
                                    data.leadId === id ? "none" : "",
                                  cursor: "pointer",
                                  textTransform: "uppercase",
                                }}
                                // className={
                                //   !isEmpty(data) && data._id === id
                                //     ? "disabled-lead-button"
                                //     : ""
                                // }
                                onClick={() => {
                                  setLoading(true)
                                  setEventDataLoading(true)
                                  setEventCoordinatorLoading(true)
                                  setMultipleLeadId(data.leadId)
                                  setModuleMode(moduleMode)
                                  setTimeout(() => {
                                    history.push(
                                      `/client-details/${data.leadId}`
                                    )
                                    // setMultipleLeadId(data.leadId)
                                    setLoading(false)
                                  }, 3000)
                                  setTimeout(() => {
                                    // history.push(
                                    //   `/client-details/${data.leadId}`
                                    // )
                                    // setMultipleLeadId(data.leadId)
                                    setEventCoordinatorLoading(false)
                                    setEventDataLoading(false)
                                  }, 6000)
                                }}
                              >
                                {data && data.leadNumber ? data.leadNumber : ""}
                              </div>
                            )
                          })
                        : ""}
                    </Col>
                    {loading ? (
                      <Modal
                        show={loading}
                        style={{ width: "6.7%", margin: "18% 50%" }}
                      >
                        <Modal.Body>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant="success"
                            className="mx-2"
                            color="success"
                          />
                          {/* <span>Loading...</span> */}
                        </Modal.Body>
                      </Modal>
                    ) : (
                      ""
                    )}
                    {/* New lead clone modal section */}
                    {newLeadModal && (
                      <Modal
                        size="md"
                        show={newLeadModal}
                        onHide={handleNewLeadClose}
                      >
                        <Modal.Header
                          style={{
                            background: "#e40d8c",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#ffffff",
                          }}
                        >
                          New Lead Confirmation
                        </Modal.Header>
                        <Modal.Body>
                          <Col>
                            <Row className="d-flex flex-row">
                              <Col
                                xl="12"
                                lg="12"
                                md="12"
                                sm="12"
                                xs="12"
                                className="d-flex flex-row mt-2"
                              >
                                <Input
                                  type="checkbox"
                                  name="clientDetailsChecked"
                                  value={clientDetailsChecked}
                                  onChange={(e) =>
                                    setClientDetailsChecked(e.target.checked)
                                  }
                                />
                                <Label className="employee-label mx-2">
                                  Copy Client Details
                                </Label>
                              </Col>
                            </Row>
                          </Col>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            className="btn btn-danger"
                            onClick={handleNewLeadClose}
                          >
                            No
                          </Button>
                          <Button
                            variant="primary"
                            className="btn btn-success"
                            onClick={() => {
                              newLeadCreationConfirm()
                              // removeEventDetails()
                            }}
                          >
                            Yes
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    )}

                    {/* Company Details Start */}

                    <Col style={{ marginTop: "25px" }}>
                      <Row style={{ flexWrap: "wrap" }}>
                        <Col key={"1"} sm={3}>
                          <p
                            style={{
                              color: "#ABABAB",
                            }}
                          >
                            {"Company"} :
                          </p>
                          <p
                            style={{
                              fontWeight: "550",
                            }}
                          >
                            {!isEmpty(record_client_profile) &&
                              !isEmpty(leadDetails) &&
                              leadDetails[0].company
                              ? leadDetails[0].company
                              : "--"}
                          </p>
                        </Col>
                        <Col key={"2"} sm={3}>
                          <p
                            style={{
                              color: "#ABABAB",
                            }}
                          >
                            {"Branch"} :
                          </p>
                          <p
                            style={{
                              fontWeight: "550",
                            }}
                          >
                            {!isEmpty(record_client_profile) &&
                              !isEmpty(leadDetails) &&
                              leadDetails[0].branch
                              ? leadDetails[0].branch
                              : "--"}
                          </p>
                        </Col>
                        <Col key={"3"} sm={3}>
                          <p
                            style={{
                              color: "#ABABAB",
                            }}
                          >
                            {"Service"} :
                          </p>
                          <p
                            style={{
                              fontWeight: "550",
                            }}
                          >
                            {!isEmpty(record_client_profile) &&
                              !isEmpty(leadDetails) &&
                              leadDetails[0].service
                              ? leadDetails[0].service
                              : "--"}
                          </p>
                        </Col>
                        <Col key={"4"} sm={3}>
                          {moduleMode === "EC" ||
                            moduleMode === "Operations" ||
                            moduleMode === "Operations" ? (
                            <>
                              <p
                                style={{
                                  color: "#ABABAB",
                                }}
                              >
                                {"Priority"} :
                              </p>
                              <p
                                style={{
                                  fontWeight: "500",
                                }}
                              >
                                {!isEmpty(record_client_profile) &&
                                  !isEmpty(leadDetails) &&
                                  leadDetails[0].priorityStatus
                                  ? leadDetails[0].priorityStatus
                                  : "--"}
                              </p>
                            </>
                          ) : (
                            <>
                              <p
                                style={{
                                  color: "#ABABAB",
                                }}
                              >
                                {" "}
                                {"Source"} :
                              </p>
                              <p
                                style={{
                                  fontWeight: "500",
                                }}
                              >
                                {!isEmpty(record_client_profile) &&
                                  !isEmpty(leadDetails) &&
                                  leadDetails[0].source
                                  ? leadDetails[0].source
                                  : "--"}
                              </p>
                            </>
                          )}
                        </Col>
                        <Col key={"5"} sm={3}>
                          {moduleMode === "EC" ||
                            moduleMode === "Operations" ? (
                            <>
                              <p
                                style={{
                                  color: "#ABABAB",
                                }}
                              >
                                {"Client Profile"} :
                              </p>
                              <p
                                style={{
                                  fontWeight: "500",
                                }}
                              >
                                {"--"}
                              </p>
                            </>
                          ) : (
                            <>
                              <p
                                style={{
                                  color: "#ABABAB",
                                }}
                              >
                                {"Sub Source"} :
                              </p>
                              <p
                                style={{
                                  fontWeight: "500",
                                }}
                              >
                                {" "}
                                {!isEmpty(record_client_profile) &&
                                  !isEmpty(leadDetails) &&
                                  leadDetails[0].subSource
                                  ? record_client_profile.leadDetails[0]
                                    .subSource
                                  : "--"}
                              </p>
                            </>
                          )}
                        </Col>
                        <Col key={"6"} sm={3}>
                          {moduleMode === "EC" ||
                            moduleMode === "Operations" ? (
                            <>
                              <p
                                style={{
                                  color: "#ABABAB",
                                }}
                              >
                                {"Clearance Status"} :
                              </p>
                              <div
                                style={{
                                  fontWeight: "500",
                                }}
                              >
                                <button
                                  style={{
                                    fontSize: "13px",
                                    borderRadius: "3px",
                                    border: "none",
                                    color: "#ffffff",
                                    backgroundColor:
                                      !isEmpty(record_client_profile) &&
                                        leadDetails.length > 0 &&
                                        !isEmpty(leadDetails[0].leadClearance) &&
                                        leadDetails[0].leadClearance.type ==
                                        "paid"
                                        ? "#34c38f"
                                        : (leadDetails.length > 0 &&
                                          !isEmpty(
                                            leadDetails[0].leadClearance
                                          ) &&
                                          leadDetails[0].leadClearance.type ==
                                          "partialpaid") ||
                                          (leadDetails.length > 0 &&
                                            !isEmpty(
                                              leadDetails[0].leadClearance
                                            ) &&
                                            leadDetails[0].leadClearance.type ==
                                            "partialPaid")
                                          ? "#f1734f"
                                          : "#f46a6a",
                                    padding: "2px 5px",
                                  }}
                                >
                                  {!isEmpty(record_client_profile) &&
                                    !isEmpty(leadDetails) &&
                                    leadDetails[0].ecClearanceStatusName
                                    ? leadDetails[0].ecClearanceStatusName
                                    : "--"}
                                </button>
                              </div>
                            </>
                          ) : (
                            <>
                              <p
                                style={{
                                  color: "#ABABAB",
                                }}
                              >
                                {"Sales Urge"} :
                              </p>
                              <Badge
                                color="success"
                                style={{
                                  padding: "6px 15px",
                                  fontSize: "14px",
                                }}
                              >
                                {!isEmpty(record_client_profile) &&
                                  !isEmpty(leadDetails) &&
                                  leadDetails[0].salesUrge
                                  ? leadDetails[0].salesUrge
                                  : "--"}
                              </Badge>
                            </>
                          )}
                        </Col>
                        <Col key={"7"} sm={3}>
                          {moduleMode === "EC" ||
                            moduleMode === "Operations" ? (
                            <>
                              <p
                                style={{
                                  color: "#ABABAB",
                                }}
                              >
                                {"Payment Status"} :
                              </p>
                              <div
                                style={{
                                  fontWeight: "500",
                                }}
                              >
                                <Badge
                                  color={
                                    !isEmpty(record_client_profile) &&
                                      !isEmpty(leadDetails) &&
                                      leadDetails[0].isPaymentStatus ===
                                      "Not Completed"
                                      ? "danger"
                                      : "success"
                                  }
                                  style={{ fontSize: "13px" }}
                                >
                                  {!isEmpty(record_client_profile) &&
                                    !isEmpty(leadDetails) &&
                                    leadDetails[0].isPaymentStatus ===
                                    "Not Completed"
                                    ? "No"
                                    : "Yes"}
                                </Badge>
                              </div>
                            </>
                          ) : (
                            <>
                              <p
                                style={{
                                  color: "#ABABAB",
                                }}
                              >
                                {"Priority Status"} :
                              </p>
                              <p
                                style={{
                                  fontWeight: "500",
                                }}
                              >
                                {!isEmpty(record_client_profile) &&
                                  !isEmpty(leadDetails) &&
                                  leadDetails[0].priorityStatus
                                  ? leadDetails[0].priorityStatus
                                  : "--"}
                              </p>
                            </>
                          )}
                        </Col>
                        <Col key={"8"} sm={3}>
                          {moduleMode === "EC" ||
                            moduleMode === "Operations" ? (
                            <>
                              <p
                                style={{
                                  color: "#ABABAB",
                                }}
                              >
                                {"Allow Order"} :
                              </p>
                              <div
                                style={{
                                  fontWeight: "500",
                                }}
                              >
                                <Badge
                                  color={
                                    !isEmpty(record_client_profile) &&
                                      !isEmpty(leadDetails) &&
                                      leadDetails[0].isAllowOrderStatus ===
                                      "Not Completed"
                                      ? "danger"
                                      : "success"
                                  }
                                  style={{ fontSize: "13px" }}
                                >
                                  {!isEmpty(record_client_profile) &&
                                    !isEmpty(leadDetails) &&
                                    leadDetails[0].isAllowOrderStatus ===
                                    "Not Completed"
                                    ? "No"
                                    : "Yes"}
                                </Badge>
                              </div>
                            </>
                          ) : (
                            <>
                              <p
                                style={{
                                  color: "#ABABAB",
                                }}
                              >
                                {"Attachment"} :
                              </p>
                              <p
                                style={{
                                  fontWeight: "500",
                                }}
                              >
                                {!isEmpty(record_client_profile) &&
                                  !isEmpty(leadDetails) &&
                                  leadDetails[0].Attachment
                                  ? leadDetails[0].Attachment
                                  : "--"}
                              </p>
                            </>
                          )}
                        </Col>
                        {moduleMode != "Data" ? (
                          <Col key={"9"} sm={3}>
                            {moduleMode === "EC" ||
                              moduleMode === "Operations" ? (
                              <>
                                <p
                                  style={{
                                    color: "#ABABAB",
                                  }}
                                >
                                  {"CheckList Status"} :
                                </p>
                                <div
                                  style={{
                                    fontWeight: "500",
                                  }}
                                >
                                  <Badge
                                    // color="danger"
                                    style={{ fontSize: "13px" }}
                                    color={
                                      !isEmpty(record_client_profile) &&
                                        !isEmpty(leadDetails) &&
                                        leadDetails[0].checkListPercentage > 0
                                        ? "success"
                                        : "danger"
                                    }
                                  >
                                    {!isEmpty(record_client_profile) &&
                                      !isEmpty(leadDetails) &&
                                      leadDetails[0].checkListPercentage > 0
                                      ? "Completed"
                                      : "InProcess"}
                                  </Badge>
                                </div>
                              </>
                            ) : (
                              <>
                                <p
                                  style={{
                                    color: "#ABABAB",
                                  }}
                                >
                                  {"Remarks"} :
                                </p>
                                <p style={{}}>
                                  {!isEmpty(record_client_profile) &&
                                    !isEmpty(leadDetails) &&
                                    leadDetails[0].Remarks
                                    ? leadDetails[0].Remarks
                                    : "--"}
                                </p>
                              </>
                            )}
                          </Col>
                        ) : (
                          ""
                        )}
                        {moduleMode != "Data" ? (
                          <Col key={"10"} sm={3}>
                            {moduleMode === "EC" ||
                              moduleMode === "Operations" ? (
                              <>
                                <p
                                  style={{
                                    color: "#ABABAB",
                                  }}
                                >
                                  {"Team Schedule"} :
                                </p>
                                <div
                                  style={{
                                    fontWeight: "500",
                                  }}
                                >
                                  <Badge
                                    color={
                                      !isEmpty(record_client_profile) &&
                                        !isEmpty(leadDetails) &&
                                        leadDetails[0].teamScheduleStatus ===
                                        "Not Completed"
                                        ? "danger"
                                        : "success"
                                    }
                                    style={{ fontSize: "13px" }}
                                  >
                                    {!isEmpty(record_client_profile) &&
                                      !isEmpty(leadDetails) &&
                                      leadDetails[0].teamScheduleStatus !==
                                      "Not Completed"
                                      ? "Completed"
                                      : "InProcess"}
                                  </Badge>
                                </div>
                              </>
                            ) : (
                              <>
                                <p
                                  style={{
                                    color: "#ABABAB",
                                  }}
                                >
                                  {"Lead Status"} :
                                </p>
                                <p
                                  className="paragrap-pink"
                                  style={{
                                    fontWeight: "500",
                                  }}
                                >
                                  {!isEmpty(record_client_profile) &&
                                    !isEmpty(leadDetails) &&
                                    leadDetails[0].leadStatus
                                    ? leadDetails[0].leadStatus
                                    : "--"}
                                </p>
                              </>
                            )}
                          </Col>
                        ) : (
                          ""
                        )}
                        {/* {console.log("moduleMode:", moduleMode)} */}

                        {/* <Col key={"11"} sm={3}>
                            {moduleMode === "EC" ||
                            moduleMode === "Operations" ?
                                  (
                              <>
                                <p
                                  style={{
                                    color: "#ABABAB",
                                  }}
                                >
                                  {"Equipment Schedule"} :
                                </p>
                                <div
                                  style={{
                                    fontWeight: "500",
                                  }}
                                >
                                  <Badge
                                    color={
                                      !isEmpty(record_client_profile) &&
                                      !isEmpty(leadDetails) &&
                                      leadDetails[0].equipmentScheduleStatus ===
                                        "Not Completed"
                                        ? "danger"
                                        : "success"
                                    }
                                    style={{ fontSize: "13px" }}
                                  >
                                    {!isEmpty(record_client_profile) &&
                                    !isEmpty(leadDetails) &&
                                    leadDetails[0].equipmentScheduleStatus !==
                                      "Not Completed"
                                      ? "Completed"
                                      : "InProcess"}
                                  </Badge>
                                </div>
                              </>
                            ) : (
                              <>
                                <p
                                  style={{
                                    color: "#ABABAB",
                                  }}
                                >
                                  {"Over all Status"} :
                                </p>
                                <p
                                  style={{
                                    fontWeight: "500",
                                  }}
                                >
                                  {moduleMode === "Data"
                                    ?!isEmpty(record_client_profile) &&
                                    !isEmpty(leadDetails) &&
                                    leadDetails[0].dataOverAllStatus
                                  ? leadDetails[0].dataOverAllStatus
                                  : "--": !isEmpty(record_client_profile) &&
                                      !isEmpty(leadDetails) &&
                                      leadDetails[0].overAllStatus
                                      ? leadDetails[0].overAllStatus
                                      : "--"
                                     }
                                </p>
                              </>
                            )}
                          </Col> */}
                        {moduleMode !== "Data" && (
                          <Col key={"11"} sm={3}>
                            {moduleMode === "EC" ||
                              moduleMode === "Operations" ? (
                              <>
                                <p style={{ color: "#ABABAB" }}>
                                  {"Equipment Schedule"} :
                                </p>
                                <div style={{ fontWeight: "500" }}>
                                  <Badge
                                    color={
                                      !isEmpty(record_client_profile) &&
                                        !isEmpty(leadDetails) &&
                                        leadDetails[0].equipmentScheduleStatus ===
                                        "Not Completed"
                                        ? "danger"
                                        : "success"
                                    }
                                    style={{ fontSize: "13px" }}
                                  >
                                    {!isEmpty(record_client_profile) &&
                                      !isEmpty(leadDetails) &&
                                      leadDetails[0].equipmentScheduleStatus !==
                                      "Not Completed"
                                      ? "Completed"
                                      : "InProcess"}
                                  </Badge>
                                </div>
                              </>
                            ) : (
                              <>
                                <p style={{ color: "#ABABAB" }}>
                                  {"Over all Status"} :
                                </p>
                                <p style={{ fontWeight: "500" }}>
                                  {!isEmpty(record_client_profile) &&
                                    !isEmpty(leadDetails) &&
                                    leadDetails[0].overAllStatus
                                    ? leadDetails[0].overAllStatus
                                    : "--"}
                                </p>
                              </>
                            )}
                          </Col>
                        )}
                        {moduleMode == "SALES" &&
                          (<Col key={"12"} sm={3}>

                            <>
                              <p
                                style={{
                                  color: "#ABABAB",
                                }}
                              >
                                {"Client Appearance Rating"} :
                              </p>
                              <div className="d-flex"
                              >
                                <ReactStars
                                  count={5}
                                  size={21}
                                  isHalf={true}
                                  a11y={true}
                                  name="clientAppearanceRating"
                                  value={clientAppearanceRating}
                                  {...ratingProps}
                                  activeColor="#f3d329"
                                  onChange={(e) => {
                                    handleClientAppearanceRating(e)
                                  }}
                                />
                                <div style={{ marginTop: "6px" }}>{`(${!isEmpty(record_client_profile) &&
                                  !isEmpty(leadDetails) &&
                                  leadDetails[0].clientAppearanceRating
                                  ? leadDetails[0].clientAppearanceRating
                                  : 0}  Ratings)`}</div>

                              </div>
                            </>
                          </Col>)}
                        {moduleMode == "SALES" &&
                          (<Col key={"13"} sm={6} className="mb-3">
                            <>
                              <p style={{ fontWeight: "bold" }}>{"ZG Plus Client"} :</p>

                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "10px",
                                  justifyContent: "flex-start",
                                }}
                              >
                                {/* {!isEmpty(leadDetails) &&
                                  leadDetails[0].zgPlusClient ? (
                                  leadDetails[0].zgPlusClient.filter(item =>
                                    !leadDetails.some(data => data.leadNumber === item)
                                  ).length > 0 ? (
                                    leadDetails[0].zgPlusClient.filter(item =>
                                      !leadDetails.some(data => data.leadNumber === item)
                                    ).map((m, index) => (
                                      <span
                                        key={`${m}-${index}`}
                                        className="badge"
                                        style={{
                                          padding: "6px 2px",
                                          fontSize: "16px",
                                          cursor: "pointer",
                                          backgroundColor: getBadgeColor(m),
                                          flexBasis: "calc(33.33% - 10px)",
                                          flexGrow: 0,
                                          marginBottom: "10px",
                                          textAlign: "center",
                                        }}
                                        onClick={() => handleZgFollowupHistory(m)}
                                      >
                                        {m}
                                      </span>
                                    ))
                                  ) : (
                                    <span>--</span>
                                  )
                                ) : (
                                  <span>--</span>
                                )} */}
                                {!isEmpty(leadDetails) && !isEmpty(record_client_profile.leadDetails) ? (
                                  record_client_profile.leadDetails
                                    .filter(l => !leadDetails.some(m => m.companyId === l.companyId))
                                    .map((m, index) => (
                                      <span
                                        key={index}
                                        className="badge"
                                        style={{
                                          padding: "6px 2px",
                                          fontSize: "16px",
                                          cursor: "pointer",
                                          backgroundColor: getBadgeColor(m.leadNumber),
                                          flexBasis: "calc(33.33% - 10px)",
                                          flexGrow: 0,
                                          marginBottom: "10px",
                                          textAlign: "center",
                                        }}
                                        onClick={() => handleZgFollowupHistory(m.leadId)}
                                      >
                                        {m.leadNumber}
                                      </span>
                                    ))
                                ) : (
                                  <span>--</span>
                                )}

                              </div>
                            </>
                          </Col>)}
                        {moduleMode == "SALES" &&
                          (<Col key={"14"} sm={3} className="mb-3">
                            <>
                              <p style={{ fontWeight: "bold" }}>{"Client Type"} :</p>
                              <div style={{ display: "flex" }}>

                                {!isEmpty(leadDetails) &&
                                  leadDetails[0].leadQuotationRange ? (
                                  <span
                                    className={"badge"}
                                    style={{
                                      backgroundColor:
                                        leadDetails[0].leadQuotationRange === "Green" ? "#28a745" :
                                          leadDetails[0].leadQuotationRange === "Yellow" ? "#fce303" :
                                            leadDetails[0].leadQuotationRange === "Orange" ? "#FFA500" :
                                              leadDetails[0].leadQuotationRange === "Blue" ? "#033dfc" :
                                                "",
                                      display: "inline-block",
                                      width: "35px",        // Equal width and height for a circle
                                      height: "35px",
                                      borderRadius: "50%",
                                    }}
                                  />
                                ) : (
                                  <span>--</span>

                                )}
                              </div>

                            </>
                          </Col>)}
                        {moduleMode == "SALES" &&
                          (<>
                            <Col key={"14"} sm={3} className="mt-2">
                              <div className="d-flex flex-row">
                                {statusList.map((status, index) => {
                                  return (
                                    <div className="d-flex flex-row" key={index}>
                                      <Input
                                        type="checkbox"
                                        name="onlyEngagement"
                                        value={status.value}
                                        checked={onlyEngagement === status.value}
                                        onChange={(e) =>
                                          handleStatusChange(e, status.value)
                                        }
                                        className="font-size-15"
                                      />
                                      <Label
                                        className="mx-2"
                                        style={{ marginTop: "2px", fontSize: "12px", fontWeight: "bold" }}
                                      >
                                        {status.label}
                                      </Label>
                                    </div>
                                  )
                                })}


                              </div>
                              <div style={{ display: "flex" }}>
                                {engageRemove == true ? (
                                  <>
                                    <span
                                      className="badge"
                                      style={{
                                        display: "inline-block",
                                        width: "35px",
                                        height: "35px",
                                        borderRadius: "50%",
                                        backgroundColor: "#c5ff00",
                                      }}
                                    />
                                    
                                  
                                  </>
                                ) : (
                                  "--"
                                )}
                              </div>
                              {!isEmpty(record_client_profile) &&
                                      !isEmpty(leadDetails) &&
                                      leadDetails[0].onlyEngagementStatus 
                                      &&`(${leadDetails[0].onlyEngagementStatus=="mainEventBooked"?"Main Event Booked":
                                        leadDetails[0].onlyEngagementStatus=="mainEventNotBooked"?"Main Event Not Booked":""
                                      })`}
                            </Col>
                            <Col key={"14"} sm={3} className="mt-2">
                              <div className="d-flex flex-row">
                                {goodCLientList.map((status, index) => {
                                  return (
                                    <div className="d-flex flex-row" key={index}>
                                      <Input
                                        type="checkbox"
                                        name="goodLookingClient"
                                        value={status.value}
                                        checked={goodLookingClient === status.value}
                                        onChange={(e) =>
                                          handleGoodChange(e, status.value)
                                        }
                                        className="font-size-15"
                                      />
                                      <Label
                                        className="mx-2"
                                        style={{ marginTop: "2px", fontSize: "12px", fontWeight: "bold" }}
                                      >
                                        {status.label}
                                      </Label>
                                    </div>
                                  )
                                })}


                              </div>
                              <div style={{ display: "flex" }}>
                                {goodClientRemove == true ?
                                  <span
                                    className={"badge"}
                                    style={{
                                      display: "inline-block",
                                      width: "35px",
                                      height: "35px",
                                      borderRadius: "50%",
                                      color: "#FFD700",
                                      backgroundColor: "#BF55EC"
                                    }}
                                  />
                                  : "--"}
                              </div>
                            </Col>
                            <Col key={"14"} sm={3} className="mt-2">
                              <div className="d-flex flex-row">
                                {highEndClientList.map((status, index) => {
                                  return (
                                    <div className="d-flex flex-row" key={index}>
                                      <Input
                                        type="checkbox"
                                        name="highEndClientList"
                                        value={status.value}
                                        checked={highEndClient === status.value}
                                        onChange={(e) =>
                                          highEndClientChange(e, status.value)
                                        }
                                        className="font-size-15"
                                      />
                                      <Label
                                        className="mx-2"
                                        style={{ marginTop: "2px", fontSize: "12px", fontWeight: "bold" }}
                                      >
                                        {status.label}
                                      </Label>
                                    </div>
                                  )
                                })}


                              </div>
                              <div style={{ display: "flex" }}>
                                {highEndClientRemove == true ?
                                  <span
                                    className={"badge"}
                                    style={{
                                      display: "inline-block",
                                      width: "35px",
                                      height: "35px",
                                      borderRadius: "50%",
                                      color: "#BF55EC",
                                      backgroundColor: "#FFD700"
                                    }}
                                  />
                                  : "--"}
                              </div>
                            </Col>
                          </>
                          )}
                        {moduleMode == "Data" ? (
                          <>
                            <Col key={"16"} sm={3}>
                              {moduleMode === "Data" ? (
                                <>
                                  <>
                                    <p
                                      style={{
                                        color: "#ABABAB",
                                      }}
                                    >
                                      {"Over all Status"} :
                                    </p>
                                    <p
                                      style={{
                                        fontWeight: "500",
                                      }}
                                    >
                                      {!isEmpty(record_client_profile) &&
                                        !isEmpty(leadDetails) &&
                                        leadDetails[0].dataOverAllStatus
                                        ? leadDetails[0].dataOverAllStatus
                                        : "--"}
                                    </p>
                                  </>
                                </>
                              ) : (
                                ""
                              )}
                            </Col>
                            <Col key={"16"} sm={3}>
                              {moduleMode === "Data" ? (
                                <>
                                  <p
                                    style={{
                                      color: "#ABABAB",
                                    }}
                                  >
                                    {"Bride Name"} :
                                  </p>
                                  <p className="paragrap-pink">
                                    {!isEmpty(record_client_profile) &&
                                      !isEmpty(leadDetails) &&
                                      leadDetails[0].brideName
                                      ? leadDetails[0].brideName
                                      : "--"}
                                  </p>
                                </>
                              ) : (
                                ""
                              )}
                            </Col>
                            <Col key={"17"} sm={3}>
                              {moduleMode === "Data" ? (
                                <>
                                  <p
                                    style={{
                                      color: "#ABABAB",
                                    }}
                                  >
                                    {"Groom Name"} :
                                  </p>
                                  <p className="paragrap-pink">
                                    {!isEmpty(record_client_profile) &&
                                      !isEmpty(leadDetails) &&
                                      leadDetails[0].groomName
                                      ? leadDetails[0].groomName
                                      : "--"}
                                  </p>
                                </>
                              ) : (
                                ""
                              )}
                            </Col>
                          </>
                        ) : (
                          <>
                            <Col key={"11"} sm={3}>
                              {moduleMode === "EC" ||
                                moduleMode === "Operations" ? (
                                <>
                                  <p
                                    style={{
                                      color: "#ABABAB",
                                    }}
                                  >
                                    {"Ec Status"} :
                                  </p>
                                  <p className="paragrap-pink">
                                    {!isEmpty(record_client_profile) &&
                                      !isEmpty(leadDetails) &&
                                      leadDetails[0].ecProcessStatus
                                      ? leadDetails[0].ecProcessStatus
                                      : "--"}
                                  </p>
                                </>
                              ) : (
                                ""
                              )}
                              <p
                                style={{
                                  fontWeight: "500",
                                }}
                              ></p>
                            </Col>
                            <Col key={"12"} sm={3}>
                              {moduleMode === "EC" ||
                                moduleMode === "Operations" ? (
                                <>
                                  <p
                                    style={{
                                      color: "#ABABAB",
                                    }}
                                  >
                                    {"Service Confirmation"} :
                                  </p>
                                  <div
                                    style={{
                                      fontWeight: "500",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <Badge
                                      color={
                                        !isEmpty(record_client_profile) &&
                                          !isEmpty(leadDetails) &&
                                          leadDetails[0].serviceConfirmation ===
                                          "Not Completed"
                                          ? "danger"
                                          : "success"
                                      }
                                      style={{ fontSize: "13px" }}
                                      onClick={() =>
                                        serviceConfirmationPreview()
                                      }
                                    >
                                      {/* {!isEmpty(record_client_profile) &&
                                  !isEmpty(leadDetails) &&
                                  leadDetails[0].serviceConfirmation 
                                  // !==
                                  //   "Not Completed"
                                  //   ? "Completed"
                                  //   : "InProcess"
                                    } */}
                                      Service Confirmation
                                    </Badge>
                                  </div>
                                </>
                              ) : (
                                ""
                              )}
                              <p
                                style={{
                                  fontWeight: "500",
                                }}
                              ></p>
                            </Col>
                            {moduleMode == "Operations" && (
                              <Col key={"13"} sm={3}>
                                {moduleMode == "Operations" ? (
                                  <>
                                    <p
                                      style={{
                                        color: "#ABABAB",
                                      }}
                                    >
                                      {"Client Complete"} :
                                    </p>
                                    <div
                                      style={{
                                        fontWeight: "500",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {!isEmpty(record_client_profile) &&
                                        !isEmpty(leadDetails) &&
                                        leadDetails[0].isclientCompleted ==
                                        true ? (
                                        <Badge
                                          color={
                                            !isEmpty(record_client_profile) &&
                                              !isEmpty(leadDetails) &&
                                              leadDetails[0].isclientCompleted ==
                                              true
                                              ? "success"
                                              : "danger"
                                          }
                                          style={{ fontSize: "13px", padding: "10px" }}
                                          onClick={() =>
                                            setClientCompleteModal(true)
                                          }
                                        >
                                          Complete
                                        </Badge>
                                      ) : (
                                        <Badge
                                          color={
                                            !isEmpty(record_client_profile) &&
                                              !isEmpty(leadDetails) &&
                                              leadDetails[0].isclientCompleted ==
                                              true
                                              ? "success"
                                              : "danger"
                                          }
                                          style={{ fontSize: "13px", padding: "10px" }}
                                          onClick={() =>
                                            setClientCompleteModal(true)
                                          }
                                        >
                                          Complete
                                        </Badge>
                                      )}
                                    </div>
                                  </>
                                ) : (
                                  ""
                                )}
                                <p
                                  style={{
                                    fontWeight: "500",
                                  }}
                                ></p>
                              </Col>
                            )}
                            <Col key={"14"} sm={3}>
                              {(moduleMode === "EC" &&
                                menuName == "ManageEc") ||
                                (moduleMode === "EC" &&
                                  menuName == "MyClientEc") ? (
                                <>
                                  <p
                                    style={{
                                      color: "#ABABAB",
                                    }}
                                  >
                                    {"Event Complete"} :
                                  </p>
                                  <button
                                    style={{
                                      background: "#34c38f",
                                      border: "none",
                                      cursor: "pointer",
                                      color: "white",
                                      padding: "5px",
                                      borderRadius: "4px",
                                    }}
                                    onClick={() => {
                                      if (
                                        !isEmpty(record_client_profile) &&
                                        !isEmpty(leadDetails) &&
                                        !isEmpty(
                                          leadDetails[0].leadClearance
                                        ) &&
                                        leadDetails[0].ecClearanceStatus ===
                                        "PS24"
                                      ) {
                                        setEventCompleteModal(true)
                                        setEventCompleteMode("Approved")
                                      } else {
                                        setEventCompleteModal(true)
                                        setEventCompleteMode("Processing")
                                      }
                                    }}
                                  >
                                    Event Complete
                                  </button>
                                </>
                              ) : (
                                ""
                              )}
                              <p
                                style={{
                                  fontWeight: "500",
                                }}
                              ></p>
                            </Col>
                            {/* //Event Cancel section */}
                            <Col key={"15"} sm={3}>
                              {(moduleMode === "EC" &&
                                menuName == "ManageEc") ||
                                (moduleMode === "EC" &&
                                  menuName == "MyClientEc") ? (
                                <>
                                  <p
                                    style={{
                                      color: "#ABABAB",
                                    }}
                                  >
                                    {"Event Cancel"} :
                                  </p>
                                  <button
                                    style={{
                                      background: "#f46a6a",
                                      border: "none",
                                      cursor: "pointer",
                                      color: "white",
                                      padding: "5px",
                                      borderRadius: "4px",
                                    }}
                                    onClick={() => {
                                      setEventCancelModal(true)
                                    }}
                                  >
                                    Event Cancel
                                  </button>
                                </>
                              ) : (
                                ""
                              )}
                            </Col>
                          </>
                        )}

                        {eventCompleteModal && (
                          <Modal
                            size="md"
                            show={eventCompleteModal}
                            onHide={handleEventClose}
                          >
                            <Modal.Header
                              style={{
                                background: "#e40d8c",
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#ffffff",
                              }}
                            >
                              Event Completion
                            </Modal.Header>
                            <Modal.Body>
                              {eventCompleteMode == "Processing" ? (
                                "You need to update the clearance status to Level 2 Approved..!"
                              ) : (
                                <Col>
                                  <Row className="d-flex flex-column">
                                    <Col
                                      xl="12"
                                      lg="12"
                                      md="12"
                                      sm="12"
                                      xs="12"
                                      className="mt-2"
                                    >
                                      <Label className="employee-label">
                                        Notes{" "}
                                        <span className="required mx-1">*</span>
                                      </Label>
                                      <Input
                                        type="textarea"
                                        name="eventNotes"
                                        value={eventNotes}
                                        onChange={(e) =>
                                          setEventNotes(e.target.value)
                                        }
                                        placeholder="Enter Notes"
                                        className="employee-crowd-textarea"
                                      />
                                      {simpleValidator.current.message(
                                        "notes",
                                        eventNotes,
                                        "required"
                                      )}
                                    </Col>
                                    <Col
                                      xl="12"
                                      lg="12"
                                      md="12"
                                      sm="12"
                                      xs="12"
                                      className="mt-2"
                                    >
                                      <Label className="employee-label">
                                        Attachment{" "}
                                        {/* <span className="required mx-1">*</span> */}
                                      </Label>
                                      <Input
                                        type="file"
                                        id="attachment"
                                        name="attachment"
                                        onChange={(e) =>
                                          handleChangeBookingAttachment(e)
                                        }
                                        placeholder="Attach the files"
                                        multiple
                                      />
                                      {/* {simpleValidator.current.message(
                                      "Attachment",
                                      attachment,
                                      "required"
                                    )} */}
                                    </Col>
                                  </Row>
                                </Col>
                              )}
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                variant="secondary"
                                className="btn btn-danger"
                                onClick={handleEventClose}
                              >
                                Cancel
                              </Button>
                              {eventCompleteMode == "Processing" ? (
                                ""
                              ) : (
                                <Button
                                  variant="primary"
                                  className="btn btn-success"
                                  onClick={(e) => {
                                    eventCompletionSubmit(e)
                                    // removeEventDetails()
                                  }}
                                >
                                  Submit
                                </Button>
                              )}
                            </Modal.Footer>
                          </Modal>
                        )}
                        {clientCompleteModal && (
                          <Modal
                            size="md"
                            show={clientCompleteModal}
                          //  onHide={setClientCompleteModal(false)}
                          >
                            <Modal.Header
                              style={{
                                background: "#e40d8c",
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#ffffff",
                              }}
                            >
                              Client Complete
                            </Modal.Header>
                            <Modal.Body>
                              <Col>
                                Are You Sure You Want to Client Complete?
                              </Col>
                            </Modal.Body>
                            <Modal.Footer>
                              <Button
                                variant="secondary"
                                className="btn btn-danger"
                                onClick={() => setClientCompleteModal(false)}
                              >
                                No
                              </Button>

                              <Button
                                variant="primary"
                                className="btn btn-success"
                                onClick={() => {
                                  //clientComplete()
                                  updateClientComplete()
                                }}
                              >
                                Yes
                              </Button>
                            </Modal.Footer>
                          </Modal>
                        )}
                      </Row>
                    </Col>

                    {eventCancelModal && (
                      <Modal
                        size="md"
                        show={eventCancelModal}
                        onHide={handleEventCancelModal}
                      >
                        <Modal.Header
                          style={{
                            background: "#e40d8c",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#ffffff",
                          }}
                        >
                          Event Cancel
                        </Modal.Header>
                        <Modal.Body>
                          <Col>
                            <Row className="d-flex flex-column">
                              <Col
                                xl="12"
                                lg="12"
                                md="12"
                                sm="12"
                                xs="12"
                                className="mt-2"
                              >
                                <Label className="employee-label">
                                  Notes <span className="required mx-1">*</span>
                                </Label>
                                <Input
                                  type="textarea"
                                  name="eventCancelNotes"
                                  value={eventCancelNotes}
                                  onChange={(e) =>
                                    setEventCancelNotes(e.target.value)
                                  }
                                  placeholder="Enter Notes"
                                  className="employee-crowd-textarea"
                                />
                                {simpleValidator.current.message(
                                  "eventCancelNotes",
                                  eventCancelNotes,
                                  "required"
                                )}
                              </Col>
                              <Col
                                xl="12"
                                lg="12"
                                md="12"
                                sm="12"
                                xs="12"
                                className="mt-2"
                              >
                                <Label className="employee-label">
                                  Attachment{" "}
                                  {/* <span className="required mx-1">*</span> */}
                                </Label>
                                <Input
                                  type="file"
                                  id="eventCancelAttachment"
                                  name="eventCancelAttachment"
                                  onChange={(e) =>
                                    handleChangeCancelAttachment(e)
                                  }
                                  placeholder="Attach the files"
                                  multiple
                                />
                                {/* {simpleValidator.current.message(
                                      "Attachment",
                                      attachment,
                                      "required"
                                    )} */}
                              </Col>
                            </Row>
                          </Col>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            className="btn btn-danger"
                            onClick={handleEventCancelModal}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="primary"
                            className="btn btn-success"
                            onClick={(e) => {
                              eventCancelSubmit(e)
                            }}
                          >
                            Submit
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    )}

                    {/* Company Details End*/}

                    {/* Tab Menu Start */}
                    <Col>
                      <Nav className="nav-tabs-custom nav-justified">
                        {(tabs || []).map((tab, tabIndex) => {
                          return (
                            <NavItem key={tabIndex}>
                              <NavLink
                                style={
                                  tab &&
                                    customIconActiveTab &&
                                    moduleMode === "EC" &&
                                    tab.label !== "Event Coordinator"
                                    ? {
                                      cursor: "pointer",
                                      color: "#ad9f9f",
                                      backgroundColor: "#edeaea",
                                      borderRight: "1px solid white",
                                    }
                                    : tab &&
                                      customIconActiveTab &&
                                      moduleMode === "SALES" &&
                                      tab.label !== "Sales"
                                      ? {
                                        cursor: "pointer",
                                        color: "#ad9f9f",
                                        backgroundColor: "#edeaea",
                                        borderRight: "1px solid white",
                                      }
                                      : tab &&
                                        customIconActiveTab &&
                                        moduleMode === "Operations" &&
                                        tab.label !== "Operations"
                                        ? {
                                          cursor: "pointer",
                                          color: "#ad9f9f",
                                          backgroundColor: "#edeaea",
                                          borderRight: "1px solid white",
                                        }
                                        : tab &&
                                          customIconActiveTab &&
                                          moduleMode === "Data" &&
                                          tab.label !== "Data"
                                          ? {
                                            cursor: "pointer",
                                            color: "#ad9f9f",
                                            backgroundColor: "#edeaea",
                                            borderRight: "1px solid white",
                                          }
                                          : {
                                            cursor: "pointer",
                                          }
                                }
                                // defaultValue={
                                //   // moduleMode === "EC"
                                //   tab.value === "eventCoordinator"
                                //   // : tab.value === "sales"
                                // }
                                className={classnames({
                                  active:
                                    moduleMode === "EC"
                                      ? tab && tab.label === "Event Coordinator"
                                      : moduleMode === "Operations"
                                        ? tab && tab.label === "Operations"
                                        : moduleMode === "Data"
                                          ? tab && tab.label === "Data"
                                          : tab &&
                                          customIconActiveTab === tab.label,
                                })}
                                disabled={
                                  (moduleMode === "EC" &&
                                    tab.label !== "Event Coordinator") ||
                                    (moduleMode === "SALES" &&
                                      tab.label !== "Sales") ||
                                    (moduleMode === "Operations" &&
                                      tab.label !== "Operations") ||
                                    (moduleMode === "Data" &&
                                      tab.label !== "Data")
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  // if (moduleMode !== "EC") {
                                  setCustomIconActiveTab(tab.label)
                                  // } else {
                                  //   setCustomIconActiveTab("Event Coordinator")
                                  // }
                                }}
                              >
                                <span className="tabs-content d-none d-sm-block">
                                  {tab.label}
                                </span>
                              </NavLink>
                            </NavItem>
                          )
                        })}
                      </Nav>
                    </Col>
                    {/* Tab Menu End */}

                    {/* Client Details Section */}

                    {(() => {
                      switch (customIconActiveTab) {
                        case "Sales":
                          return (
                            <Col>
                              <Col md="12" lg="12" xl="12">
                                <Nav className="nav">
                                  {buttonSchema.map((data, index) => {
                                    return (
                                      <button
                                        key={index}
                                        type="submit"
                                        className={
                                          qcApproved === "PS6" ||
                                            qcApproved === "PS9" ||
                                            qcApproved === "PS17"
                                            ? data.color
                                            : (qcApproved !== "PS6" &&
                                              data.label === "Sales Entry") ||
                                              // (qcApproved === "PS17" &&
                                              //   data.label === "Sales Entry") ||
                                              (qcApproved === "PS19" &&
                                                data.label === "Sales Entry")
                                              ? "qc-approved disabled-button"
                                              : data.color
                                        }
                                        style={{
                                          marginRight: "20px",
                                          marginTop: "10px",
                                          textAlign: "center",
                                        }}
                                        onClick={() => {
                                          setActiveTab(data.label)
                                        }}
                                      >
                                        {data.label}
                                      </button>
                                    )
                                  })}
                                </Nav>
                              </Col>
                              {(() => {
                                switch (activeTab) {
                                  case "Client / Events":
                                    return (
                                      <>
                                        {!isEmpty(record_client_profile) &&
                                          !isEmpty(leadDetails) &&
                                          leadDetails[0].leadType ==
                                          "nonWedding" &&
                                          moduleMode == "SALES" ? (
                                          <>
                                            <Col
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                paddingTop: "20px",
                                                paddingBottom: "15px",
                                              }}
                                            >
                                              <p
                                                style={{
                                                  color: "#4486eb",
                                                  margin: "0px",
                                                  marginRight: "15px",
                                                  fontSize: "16px",
                                                  fontWeight: "500",
                                                }}
                                              >
                                                Client Details
                                              </p>

                                              {isEmpty(
                                                clientNonWeddingDataTable
                                              ) &&
                                                clientNonWeddingDataTable.length ==
                                                0 ? (
                                                <div
                                                  style={{
                                                    color: "#34C28F",
                                                    border:
                                                      "1.8px solid #34C28F",
                                                    borderRadius: "4px",
                                                    padding: "4px 10px",
                                                    height: "30px",
                                                    width: "max-content",
                                                    textAlign: "center",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    nonWeddingAddClear()
                                                  }}
                                                >
                                                  <i className="fas fa-plus"></i>{" "}
                                                  Add New
                                                </div>
                                              ) : (
                                                ""
                                              )}

                                              {/* )} */}
                                            </Col>
                                            <Col md="12" lg="12" xl="12">
                                              <Table
                                                bordered
                                                striped
                                                responsive
                                              // className="w-100"
                                              >
                                                <thead>
                                                  <tr
                                                    style={{ fontSize: "10px" }}
                                                  >
                                                    <th>S.No</th>
                                                    <th>Actions</th>
                                                    <th
                                                      style={{
                                                        minWidth: "100px",
                                                      }}
                                                    >
                                                      Client Name
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Client Designation
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Mobile No
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      WhatsApp
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Requirement
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "80px",
                                                      }}
                                                    >
                                                      Quantity
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Requirement Type
                                                    </th>

                                                    <th
                                                      style={{
                                                        minWidth: "90px",
                                                      }}
                                                    >
                                                      Budget
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Requirement Date
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Company Name
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "125px",
                                                      }}
                                                    >
                                                      Company Location
                                                    </th>

                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Client Profile
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "140px",
                                                      }}
                                                    >
                                                      Client Profile Remarks
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Email Id
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {!isEmpty(
                                                    clientNonWeddingDataTable
                                                  ) &&
                                                    clientNonWeddingDataTable.length >
                                                    0 ? (
                                                    clientNonWeddingDataTable &&
                                                    clientNonWeddingDataTable.map(
                                                      (client) => {
                                                        return (
                                                          <tr key={client.id}>
                                                            <td>
                                                              {client.sNo}
                                                            </td>
                                                            <td
                                                              className="d-flex flex-row"
                                                              style={{
                                                                paddingBottom:
                                                                  "40px",
                                                              }}
                                                            >
                                                              <Button
                                                                type="submit"
                                                                style={{
                                                                  fontSize:
                                                                    "8px",
                                                                }}
                                                                onClick={() => {
                                                                  editNonWeddingDetails(
                                                                    client
                                                                  )
                                                                }}
                                                                className={
                                                                  qcApproved ===
                                                                    "PS6" ||
                                                                    qcApproved ===
                                                                    "PS8" ||
                                                                    qcApproved ===
                                                                    "PS9" ||
                                                                    qcApproved ===
                                                                    "PS17" ||
                                                                    qcApproved ===
                                                                    "PS19"
                                                                    ? "btn btn-success buttons disabled-button"
                                                                    : "btn btn-success buttons"
                                                                }
                                                              >
                                                                <i className="fas fa-edit icon-btn"></i>
                                                              </Button>
                                                              <Button
                                                                type="submit"
                                                                style={{
                                                                  fontSize:
                                                                    "8px",
                                                                }}
                                                                className={
                                                                  qcApproved ===
                                                                    "PS6" ||
                                                                    qcApproved ===
                                                                    "PS8" ||
                                                                    qcApproved ===
                                                                    "PS9" ||
                                                                    qcApproved ===
                                                                    "PS17" ||
                                                                    qcApproved ===
                                                                    "PS19"
                                                                    ? "mx-1 btn btn-danger buttons disabled-button"
                                                                    : "mx-1 btn btn-danger buttons"
                                                                }
                                                                onClick={() => {
                                                                  setNonWeddingDeleteModal(
                                                                    true
                                                                  )
                                                                  setNonWeddingRemoveId(
                                                                    client._id
                                                                  )
                                                                }}
                                                              >
                                                                <i className="bx bx-block icon-btn"></i>
                                                              </Button>
                                                            </td>

                                                            <td>
                                                              {
                                                                client.clientName
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                client.clientDesignation
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                client.phoneNumber
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                client.whatsappNumber
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                client.requirement
                                                              }
                                                            </td>
                                                            <td>
                                                              {client.quantity}
                                                            </td>
                                                            <td>
                                                              {
                                                                client.requirementType
                                                              }
                                                            </td>
                                                            <td>
                                                              {client.budget}
                                                            </td>

                                                            <td>
                                                              {!isEmpty(client)
                                                                ? moment(
                                                                  client.requirementDate
                                                                ).format(
                                                                  "DD-MM-YYYY"
                                                                )
                                                                : "--"}
                                                            </td>
                                                            <td className="table-client-row">
                                                              {
                                                                client.companyName
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                client.companyLocation
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                client.clientProfileName
                                                              }
                                                            </td>
                                                            <td>
                                                              {
                                                                client.clientProfileRemarks
                                                              }
                                                            </td>
                                                            <td>
                                                              {client.emailId}
                                                            </td>
                                                          </tr>
                                                        )
                                                      }
                                                    )
                                                  ) : (
                                                    <>
                                                      <tr key={0}>
                                                        <td
                                                          colSpan={16}
                                                          className="text-align-center"
                                                        >
                                                          No record found
                                                        </td>
                                                      </tr>
                                                    </>
                                                  )}
                                                </tbody>
                                              </Table>
                                              {nonWeddingDeleteModal && (
                                                <Modal
                                                  show={nonWeddingDeleteModal}
                                                  onHide={handleDeleteModal}
                                                >
                                                  <Modal.Header>
                                                    Delete Client Details
                                                  </Modal.Header>
                                                  <Modal.Body>
                                                    Are you sure you want to
                                                    delete the client details ?
                                                  </Modal.Body>
                                                  <Modal.Footer>
                                                    <Button
                                                      variant="secondary"
                                                      className="btn btn-danger"
                                                      onClick={
                                                        handleDeleteModal
                                                      }
                                                    >
                                                      Close
                                                    </Button>
                                                    <Button
                                                      variant="primary"
                                                      className="btn btn-success"
                                                      onClick={() => {
                                                        handleDeleteModal()
                                                        removeNonWeddingClient()
                                                      }}
                                                    >
                                                      Delete
                                                    </Button>
                                                  </Modal.Footer>
                                                </Modal>
                                              )}
                                            </Col>
                                            <Col className="mt-2 client-detail-content mb-3">
                                              {nonWeddingModal && (
                                                <form>
                                                  <Row className="client-card-content">
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="company Name"
                                                        className="client-label"
                                                      >
                                                        Client Name
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="clientName"
                                                        value={
                                                          nonWeddingData.clientName
                                                        }
                                                        onChange={(e) =>
                                                          handleNonWeddingChange(
                                                            e
                                                          )
                                                        }
                                                        placeholder="Enter Client Name"
                                                      />
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="company Name"
                                                        className="client-label"
                                                      >
                                                        Client Designation
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="clientDesignation"
                                                        value={
                                                          nonWeddingData.clientDesignation
                                                        }
                                                        onChange={(e) =>
                                                          handleNonWeddingChange(
                                                            e
                                                          )
                                                        }
                                                        placeholder="Enter Client Designation"
                                                      />
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="brideMobile"
                                                        className="client-label"
                                                      >
                                                        Mobile No
                                                      </Label>
                                                      <PhoneInput
                                                        maxlength={15}
                                                        international
                                                        countryCallingCodeEditable={
                                                          false
                                                        }
                                                        defaultCountry={"IN"}
                                                        name="phoneNumber"
                                                        style={{ flex: "2" }}
                                                        value={
                                                          nonWeddingData.phoneNumber
                                                        }
                                                        onChange={(e) => {
                                                          const re =
                                                            /^[0-9\b/+]+$/
                                                          if (
                                                            e === "" ||
                                                            re.test(e)
                                                          ) {
                                                            handleNonWeddingChange(
                                                              {
                                                                target: {
                                                                  name: "phoneNumber",
                                                                  value: e,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        }}
                                                        id="brideMobile"
                                                        placeholder="+91"
                                                      />
                                                      {nonWeddingModal == true && inputErrors == true &&
                                                        nonWeddingData.phoneNumber
                                                          .length < 12 ? (
                                                        <p
                                                          style={{
                                                            color: "red",
                                                            fontSize: "10px",
                                                          }}
                                                        >
                                                          Enter a valid digits of Mobile No
                                                        </p>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="brideMobile"
                                                        className="client-label"
                                                      >
                                                        Whatsapp No
                                                      </Label>
                                                      <PhoneInput
                                                        maxlength={15}
                                                        international
                                                        countryCallingCodeEditable={
                                                          false
                                                        }
                                                        defaultCountry={"IN"}
                                                        name="whatsappNumber"
                                                        style={{ flex: "2" }}
                                                        value={
                                                          nonWeddingData.whatsappNumber
                                                        }
                                                        onChange={(e) => {
                                                          const re =
                                                            /^[0-9\b/+]+$/
                                                          if (
                                                            e === "" ||
                                                            re.test(e)
                                                          ) {
                                                            handleNonWeddingChange(
                                                              {
                                                                target: {
                                                                  name: "whatsappNumber",
                                                                  value: e,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        }}
                                                        id="brideMobile"
                                                        placeholder="+91"
                                                      />
                                                      {nonWeddingModal == true && inputErrors == true &&
                                                        nonWeddingData
                                                          .whatsappNumber.length <
                                                        12 ? (
                                                        <p
                                                          style={{
                                                            color: "red",
                                                            fontSize: "10px",
                                                          }}
                                                        >
                                                          Enter a valid digits of Mobile No
                                                        </p>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="brideProfile"
                                                        className="client-label"
                                                      >
                                                        Requirement
                                                      </Label>
                                                      <Input
                                                        name="requirement"
                                                        value={
                                                          nonWeddingData.requirement
                                                        }
                                                        // options={
                                                        //   recordsMetaData
                                                        //     ? recordsMetaData.clientProfileOptions
                                                        //     : []
                                                        // }
                                                        onChange={(e) =>
                                                          handleNonWeddingChange(
                                                            e
                                                          )
                                                        }
                                                        placeholder="Enter Requirement"
                                                        id="brideProfile"
                                                      // disabled
                                                      />
                                                    </Col>
                                                    <Col
                                                      xl="3"
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="profileRemarks"
                                                        className="client-label mx-2 mt-1"
                                                      >
                                                        Quantity
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="quantity"
                                                        value={
                                                          nonWeddingData.quantity
                                                        }
                                                        // // disabled={editButton}
                                                        onChange={(e) =>
                                                          handleNonWeddingChange(
                                                            e
                                                          )
                                                        }
                                                        placeholder="Enter Quantity"
                                                        id="profileRemarks"
                                                      />
                                                    </Col>
                                                    <Col
                                                      xl="3"
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="profileRemarks"
                                                        className="client-label mx-2 mt-1"
                                                      >
                                                        Requirement Type
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="requirementType"
                                                        value={
                                                          nonWeddingData.requirementType
                                                        }
                                                        // // disabled={editButton}
                                                        onChange={(e) =>
                                                          handleNonWeddingChange(
                                                            e
                                                          )
                                                        }
                                                        placeholder="Enter Requirement Type"
                                                        id="profileRemarks"
                                                      />
                                                    </Col>

                                                    <Col
                                                      xl="3"
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="profileRemarks"
                                                        className="client-label mx-2 mt-1"
                                                      >
                                                        Budget
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="budget"
                                                        value={
                                                          nonWeddingData.budget
                                                        }
                                                        // // disabled={editButton}
                                                        onChange={(e) => {
                                                          handleNonWeddingChange(
                                                            e
                                                          )
                                                        }}
                                                        placeholder="Enter Budget"
                                                        id="profileRemarks"
                                                      />
                                                    </Col>
                                                    <Col
                                                      xl="3"
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="profileRemarks"
                                                        className="client-label mx-2 mt-1"
                                                      >
                                                        Requirement Date
                                                      </Label>
                                                      <Input
                                                        type="date"
                                                        name="requirementDate"
                                                        value={
                                                          nonWeddingData.requirementDate
                                                        }
                                                        // disabled={editButton}
                                                        onChange={(e) =>
                                                          handleNonWeddingChange(
                                                            e
                                                          )
                                                        }
                                                        placeholder="Enter Profile Remarks"
                                                      />
                                                    </Col>

                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="company Name"
                                                        className="client-label"
                                                      >
                                                        Company Name
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="companyName"
                                                        value={
                                                          nonWeddingData.companyName
                                                        }
                                                        onChange={(e) =>
                                                          handleNonWeddingChange(
                                                            e
                                                          )
                                                        }
                                                        placeholder="Enter Company Name"
                                                      />
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="company Name"
                                                        className="client-label"
                                                      >
                                                        Company Location
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="companyLocation"
                                                        value={
                                                          nonWeddingData.companyLocation
                                                        }
                                                        onChange={(e) =>
                                                          handleNonWeddingChange(
                                                            e
                                                          )
                                                        }
                                                        placeholder="Enter Company Location"
                                                      />
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="company Name"
                                                        className="client-label"
                                                      >
                                                        Client Profile
                                                      </Label>
                                                      <Select
                                                        type="text"
                                                        name="nonWeddingProfile"
                                                        value={
                                                          nonWeddingProfile
                                                        }
                                                        options={
                                                          recordsMetaData
                                                            ? recordsMetaData.clientProfileOptions
                                                            : []
                                                        }
                                                        onChange={(e) =>
                                                          setNonWeddingProfile(
                                                            e
                                                          )
                                                        }
                                                        placeholder="Select Client Profile"
                                                      />
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="company Name"
                                                        className="client-label"
                                                      >
                                                        Client Profile Remarks
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="clientProfileRemarks"
                                                        value={
                                                          nonWeddingData.clientProfileRemarks
                                                        }
                                                        onChange={(e) =>
                                                          handleNonWeddingChange(
                                                            e
                                                          )
                                                        }
                                                        placeholder="Enter Client Profile Remarks"
                                                      />
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="brideEmail"
                                                        className="client-label"
                                                      >
                                                        Email Id
                                                      </Label>
                                                      <Input
                                                        type="email"
                                                        required
                                                        name="emailId"
                                                        value={
                                                          nonWeddingData.emailId
                                                        }
                                                        onChange={(e) => {
                                                          if (
                                                            !re.test(
                                                              e.target.value
                                                            )
                                                          ) {
                                                            // errors.groomEmailId = "Entered Email Id is Invalid!"
                                                            setFormErrors({
                                                              emailId:
                                                                "Entered  a valid Email Id !",
                                                            })
                                                            handleNonWeddingChange(
                                                              e
                                                            )
                                                          } else {
                                                            setFormErrors({
                                                              emailId: "",
                                                            })
                                                            handleNonWeddingChange(
                                                              e
                                                            )
                                                          }
                                                        }}
                                                        id="brideEmail"
                                                        placeholder="Enter Your Email"
                                                      />
                                                      {formErrors.emailId !==
                                                        "" ? (
                                                        <p
                                                          style={{
                                                            color: "red",
                                                            fontSize: "10px",
                                                          }}
                                                        >
                                                          {formErrors.emailId}
                                                        </p>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </Col>

                                                    <Col
                                                      xl="12"
                                                      md="12"
                                                      xs="12"
                                                      lg="12"
                                                      sm="12"
                                                    >
                                                      <div className="client-details-submit">
                                                        {nonWeddingEdit ? (
                                                          <>
                                                            <button
                                                              onClick={() => {
                                                                setNonWeddingModal(
                                                                  false
                                                                )
                                                                // handleCancel()
                                                              }}
                                                              type="button"
                                                              className="btn btn-danger btn-label form-cancel-btn"
                                                            >
                                                              <i className="bx bx-block label-icon "></i>
                                                              Cancel
                                                            </button>
                                                            <button
                                                              type="submit"
                                                              onClick={(e) => {
                                                                handleNonWeddingUpdate(
                                                                  e
                                                                )
                                                              }}
                                                              className="btn btn-success btn-label form-submit-btn"
                                                            >
                                                              <i className="bx bx-check-double label-icon"></i>
                                                              Update
                                                            </button>
                                                          </>
                                                        ) : (
                                                          <>
                                                            {" "}
                                                            <button
                                                              onClick={() => {
                                                                setNonWeddingModal(
                                                                  false
                                                                )
                                                              }}
                                                              type="button"
                                                              className="btn btn-danger btn-label form-cancel-btn"
                                                            >
                                                              <i className="bx bx-block label-icon "></i>
                                                              Cancel
                                                            </button>
                                                            <button
                                                              type="submit"
                                                              onClick={(e) => {
                                                                setNonWeddingModal(
                                                                  false
                                                                )
                                                                addNonWeddingClientDetails(
                                                                  e
                                                                )
                                                              }}
                                                              className="btn btn-success btn-label form-submit-btn"
                                                            >
                                                              <i className="bx bx-check-double label-icon"></i>
                                                              Submit
                                                            </button>
                                                          </>
                                                        )}
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </form>
                                              )}
                                            </Col>
                                          </>
                                        ) : (
                                          <>
                                            <Col
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                paddingTop: "20px",
                                                paddingBottom: "15px",
                                              }}
                                            >
                                              <p
                                                style={{
                                                  color: "#4486eb",
                                                  margin: "0px",
                                                  marginRight: "15px",
                                                  fontSize: "16px",
                                                  fontWeight: "500",
                                                }}
                                              >
                                                Client Details
                                              </p>

                                              {clientData.length < 1 ? (
                                                <div
                                                  style={{
                                                    color: "#34C28F",
                                                    border:
                                                      "1.8px solid #34C28F",
                                                    borderRadius: "4px",
                                                    padding: "4px 10px",
                                                    height: "30px",
                                                    width: "max-content",
                                                    textAlign: "center",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    addClient()
                                                    setIsEdit(false)
                                                  }}
                                                >
                                                  <i className="fas fa-plus"></i>{" "}
                                                  Add New
                                                </div>
                                              ) : (
                                                ""
                                              )}

                                              {/* )} */}
                                            </Col>
                                            {/* Data Table Section */}
                                            <Col md="12" lg="12" xl="12">
                                              <Table
                                                bordered
                                                striped
                                                responsive
                                              // className="w-100"
                                              >
                                                <thead>
                                                  <tr
                                                    style={{ fontSize: "10px" }}
                                                  >
                                                    <th>S.No</th>
                                                    <th>Actions</th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Bride Name
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "110px",
                                                      }}
                                                    >
                                                      Mobile No
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "100px",
                                                      }}
                                                    >
                                                      WhatsApp
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Email Id
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Bride Profile
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Groom Name
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Mobile No
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      WhatsApp
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Email Id
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Groom Profile
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Groom Insta Link
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Groom FB Link
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Bride Insta Link
                                                    </th>
                                                    <th
                                                      style={{
                                                        minWidth: "120px",
                                                      }}
                                                    >
                                                      Bride Fb Link
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {!isEmpty(clientDataTable) &&
                                                    clientDataTable.length > 0 ? (
                                                    clientDataTable &&
                                                    clientDataTable.map(
                                                      (client) => {
                                                        if (client._id) {
                                                          return (
                                                            <tr key={client.id}>
                                                              <td>
                                                                {client.sNo}
                                                              </td>
                                                              <td
                                                                className="d-flex flex-row"
                                                                style={{
                                                                  paddingBottom:
                                                                    "40px",
                                                                }}
                                                              >
                                                                <Button
                                                                  type="submit"
                                                                  style={{
                                                                    fontSize:
                                                                      "8px",
                                                                  }}
                                                                  onClick={() => {
                                                                    editClientDetails(
                                                                      client
                                                                    )
                                                                  }}
                                                                  className={
                                                                    qcApproved ===
                                                                      "PS6" ||
                                                                      qcApproved ===
                                                                      "PS8" ||
                                                                      qcApproved ===
                                                                      "PS9" ||
                                                                      qcApproved ===
                                                                      "PS17" ||
                                                                      qcApproved ===
                                                                      "PS19"
                                                                      ? "btn btn-success buttons disabled-button"
                                                                      : "btn btn-success buttons"
                                                                  }
                                                                >
                                                                  <i className="fas fa-edit icon-btn"></i>
                                                                </Button>
                                                                <Button
                                                                  type="submit"
                                                                  style={{
                                                                    fontSize:
                                                                      "8px",
                                                                  }}
                                                                  className={
                                                                    qcApproved ===
                                                                      "PS6" ||
                                                                      qcApproved ===
                                                                      "PS8" ||
                                                                      qcApproved ===
                                                                      "PS9" ||
                                                                      qcApproved ===
                                                                      "PS17" ||
                                                                      qcApproved ===
                                                                      "PS19"
                                                                      ? "mx-1 btn btn-danger buttons disabled-button"
                                                                      : "mx-1 btn btn-danger buttons"
                                                                  }
                                                                  onClick={() => {
                                                                    setDeleteForm(
                                                                      true
                                                                    )
                                                                    setClientRemoveId(
                                                                      client._id
                                                                    )
                                                                  }}
                                                                >
                                                                  <i className="bx bx-block icon-btn"></i>
                                                                </Button>
                                                              </td>
                                                              <td
                                                                className="table-client-row"
                                                                style={{
                                                                  textTransform:
                                                                    "uppercase",
                                                                }}
                                                              >
                                                                {
                                                                  client.brideName
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  client.brideMobileNo
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  client.brideWhatsappNo
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  client.brideEmailId
                                                                }
                                                              </td>
                                                              <td
                                                                style={{
                                                                  textTransform:
                                                                    "uppercase",
                                                                }}
                                                              >
                                                                {
                                                                  client.brideProfile
                                                                }
                                                              </td>
                                                              <td
                                                                style={{
                                                                  textTransform:
                                                                    "uppercase",
                                                                }}
                                                              >
                                                                {
                                                                  client.groomName
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  client.groomMobileNo
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  client.groomWhatsappNo
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  client.groomEmailId
                                                                }
                                                              </td>
                                                              <td
                                                                style={{
                                                                  textTransform:
                                                                    "uppercase",
                                                                }}
                                                              >
                                                                {
                                                                  client.groomProfile
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  client.groomInstLink
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  client.groomFbLink
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  client.brideInstLink
                                                                }
                                                              </td>
                                                              <td>
                                                                {
                                                                  client.brideFbLink
                                                                }
                                                              </td>
                                                            </tr>
                                                          )
                                                        }
                                                      }
                                                    )
                                                  ) : (
                                                    <>
                                                      <tr key={0}>
                                                        <td
                                                          colSpan={12}
                                                          className="text-align-center"
                                                        >
                                                          No record found
                                                        </td>
                                                      </tr>
                                                    </>
                                                  )}
                                                </tbody>

                                                {deleteForm && (
                                                  <Modal
                                                    show={deleteForm}
                                                    onHide={handleClose}
                                                  >
                                                    <Modal.Header>
                                                      Delete Client Details
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                      Are you sure you want to
                                                      delete the client details
                                                      ?
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                      <Button
                                                        variant="secondary"
                                                        className="btn btn-danger"
                                                        onClick={handleClose}
                                                      >
                                                        Close
                                                      </Button>
                                                      <Button
                                                        variant="primary"
                                                        className="btn btn-success"
                                                        onClick={() => {
                                                          handleClose()
                                                          removeClientDetails()
                                                        }}
                                                      >
                                                        Delete
                                                      </Button>
                                                    </Modal.Footer>
                                                  </Modal>
                                                )}
                                              </Table>
                                            </Col>

                                            <Col className="mt-2 client-detail-content">
                                              {openModal && (
                                                <form>
                                                  <Row className="client-card-content">
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="brideName"
                                                        className="client-label"
                                                      >
                                                        Bride Name
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="brideName"
                                                        value={
                                                          profileData.bride
                                                            .brideName
                                                        }
                                                        onChange={(e) => {
                                                          handleChange(e)
                                                        }}
                                                        id="bride_name"
                                                        placeholder="Enter Bride Name"
                                                      />
                                                    </Col>

                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="brideMobile"
                                                        className="client-label"
                                                      >
                                                        Mobile No
                                                      </Label>
                                                      <PhoneInput
                                                        maxlength={15}
                                                        international
                                                        countryCallingCodeEditable={
                                                          false
                                                        }
                                                        defaultCountry={"IN"}
                                                        name="brideMobileNo"
                                                        style={{ flex: "2" }}
                                                        value={
                                                          profileData.bride
                                                            .brideMobileNo
                                                        }
                                                        onChange={(e) => {
                                                          const re =
                                                            /^[0-9\b/+]+$/
                                                          if (
                                                            e === "" ||
                                                            re.test(e)
                                                          ) {
                                                            handleChange({
                                                              target: {
                                                                name: "brideMobileNo",
                                                                value: e,
                                                              },
                                                            })
                                                          }
                                                        }}
                                                        id="brideMobile"
                                                        placeholder="+91"
                                                      />
                                                      {clientInputErrors ==
                                                        true && profileData.bride
                                                          .brideMobileNo.length <
                                                        12 ? (
                                                        <p
                                                          style={{
                                                            color: "red",
                                                            fontSize: "10px",
                                                          }}
                                                        >
                                                          Enter a valid digits of Mobile No
                                                        </p>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="groomName"
                                                        className="client-label"
                                                      >
                                                        Groom Name
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="groomName"
                                                        value={
                                                          profileData.groom
                                                            .groomName
                                                        }
                                                        onChange={(e) =>
                                                          handleChange(e)
                                                        }
                                                        id="groomName"
                                                        placeholder="Enter Groom Name"
                                                      />
                                                    </Col>

                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="groomMobileNo"
                                                        className="client-label"
                                                      >
                                                        Mobile No
                                                      </Label>
                                                      <PhoneInput
                                                        maxlength={15}
                                                        international
                                                        countryCallingCodeEditable={
                                                          false
                                                        }
                                                        defaultCountry={"IN"}
                                                        style={{ flex: "2" }}
                                                        value={
                                                          profileData.groom
                                                            .groomMobileNo
                                                        }
                                                        onChange={(e) => {
                                                          const re =
                                                            /^[0-9\b/+]+$/
                                                          if (
                                                            e === "" ||
                                                            re.test(e)
                                                          ) {
                                                            handleChange({
                                                              target: {
                                                                name: "groomMobileNo",
                                                                value: e,
                                                              },
                                                            })
                                                          }
                                                        }}
                                                        name="groomMobileNo"
                                                        id="groomMobileNo"
                                                        placeholder="+91"
                                                      />
                                                      {clientInputErrors ==
                                                        true && profileData.groom
                                                          .groomMobileNo.length <
                                                        12 ? (
                                                        <p
                                                          style={{
                                                            color: "red",
                                                            fontSize: "10px",
                                                          }}
                                                        >
                                                          Enter a valid digits of Mobile No
                                                        </p>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="brideWhatsapp"
                                                        className="client-label"
                                                      >
                                                        Whatsapp No
                                                      </Label>
                                                      <PhoneInput
                                                        maxlength={15}
                                                        international
                                                        countryCallingCodeEditable={
                                                          false
                                                        }
                                                        defaultCountry={"IN"}
                                                        style={{ flex: "2" }}
                                                        name="brideWhatsappNo"
                                                        value={
                                                          profileData.bride
                                                            .brideWhatsappNo
                                                        }
                                                        onChange={(e) => {
                                                          //const re = /^[0-9\b]+$/
                                                          const re =
                                                            /^[0-9\b/+]+$/
                                                          if (
                                                            e === "" ||
                                                            re.test(e)
                                                          ) {
                                                            handleChange({
                                                              target: {
                                                                name: "brideWhatsappNo",
                                                                value: e,
                                                              },
                                                            })
                                                          }
                                                        }}
                                                        id="brideWhatsapp"
                                                        placeholder="+91"
                                                      />
                                                      {clientInputErrors ==
                                                        true && profileData.bride
                                                          .brideWhatsappNo
                                                          .length < 12 ? (
                                                        <p
                                                          style={{
                                                            color: "red",
                                                            fontSize: "10px",
                                                          }}
                                                        >
                                                          Enter a valid digits of Mobile No
                                                        </p>
                                                      ) : (
                                                        ""
                                                      )}
                                                      {/* {formErrors.brideWhatsappNo !== "" ? (
                                              <p
                                                style={{
                                                  color: "red",
                                                  fontSize: "10px",
                                                }}
                                              >
                                                {formErrors.brideWhatsappNo}
                                              </p>
                                            ) : (
                                              ""
                                            )} */}
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="brideEmail"
                                                        className="client-label"
                                                      >
                                                        Email Id
                                                      </Label>
                                                      <Input
                                                        type="email"
                                                        required
                                                        name="brideEmailId"
                                                        value={
                                                          profileData.bride
                                                            .brideEmailId
                                                        }
                                                        onChange={(e) => {
                                                          if (
                                                            !re.test(
                                                              e.target.value
                                                            )
                                                          ) {
                                                            // errors.groomEmailId = "Entered Email Id is Invalid!"
                                                            setFormErrors({
                                                              brideEmailId:
                                                                "Entered  a valid Email Id !",
                                                            })
                                                            handleChange(e)
                                                          } else {
                                                            setFormErrors({
                                                              brideEmailId: "",
                                                            })
                                                            handleChange(e)
                                                          }
                                                        }}
                                                        id="brideEmail"
                                                        placeholder="Enter Your mail"
                                                      />
                                                      {formErrors.brideEmailId !==
                                                        "" ? (
                                                        <p
                                                          style={{
                                                            color: "red",
                                                            fontSize: "10px",
                                                          }}
                                                        >
                                                          {
                                                            formErrors.brideEmailId
                                                          }
                                                        </p>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="groomWhatsapp"
                                                        className="client-label"
                                                      >
                                                        Whatsapp
                                                      </Label>
                                                      <PhoneInput
                                                        maxlength={15}
                                                        international
                                                        countryCallingCodeEditable={
                                                          false
                                                        }
                                                        defaultCountry={"IN"}
                                                        style={{ flex: "2" }}
                                                        name="groomWhatsappNo"
                                                        value={
                                                          profileData.groom
                                                            .groomWhatsappNo
                                                        }
                                                        onChange={(e) => {
                                                          const re =
                                                            /^[0-9\b/+]+$/
                                                          if (
                                                            e === "" ||
                                                            re.test(e)
                                                          ) {
                                                            handleChange({
                                                              target: {
                                                                name: "groomWhatsappNo",
                                                                value: e,
                                                              },
                                                            })
                                                          }
                                                        }}
                                                        id="groomWhatsapp"
                                                        placeholder="+91"
                                                      />
                                                      {clientInputErrors ==
                                                        true && profileData.groom
                                                          .groomWhatsappNo
                                                          .length < 12 ? (
                                                        <p
                                                          style={{
                                                            color: "red",
                                                            fontSize: "10px",
                                                          }}
                                                        >
                                                          Enter a valid digits of Mobile No
                                                        </p>
                                                      ) : (
                                                        ""
                                                      )}
                                                      {/* {formErrors.groomWhatsappNo !== "" ? (
                                              <p
                                                style={{
                                                  color: "red",
                                                  fontSize: "10px",
                                                }}
                                              >
                                                {formErrors.groomWhatsappNo}
                                              </p>
                                            ) : (
                                              ""
                                            )} */}
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="groomEmail"
                                                        className="client-label"
                                                      >
                                                        Email Id
                                                      </Label>
                                                      <Input
                                                        type="email"
                                                        id="groomEmail"
                                                        name="groomEmailId"
                                                        value={
                                                          profileData.groom
                                                            .groomEmailId
                                                        }
                                                        onChange={(e) => {
                                                          if (
                                                            !re.test(
                                                              e.target.value
                                                            )
                                                          ) {
                                                            // errors.groomEmailId = "Entered Email Id is Invalid!"
                                                            setFormErrors({
                                                              groomEmailId:
                                                                "Enter a valid Email Id !",
                                                            })
                                                            handleChange(e)
                                                          } else {
                                                            setFormErrors({
                                                              groomEmailId: "",
                                                            })
                                                            handleChange(e)
                                                          }
                                                        }}
                                                        placeholder="Enter Your mail"
                                                      />
                                                      {formErrors.groomEmailId !==
                                                        "" ? (
                                                        <p
                                                          style={{
                                                            color: "red",
                                                            fontSize: "10px",
                                                          }}
                                                        >
                                                          {
                                                            formErrors.groomEmailId
                                                          }
                                                        </p>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="brideProfile"
                                                        className="client-label"
                                                      >
                                                        Bride Profile
                                                      </Label>
                                                      <Select
                                                        name="brideProfile"
                                                        value={
                                                          // profileData.bride.
                                                          brideProfile
                                                        }
                                                        options={
                                                          recordsMetaData
                                                            ? recordsMetaData.clientProfileOptions
                                                            : []
                                                        }
                                                        onChange={(e) =>
                                                          setBrideProfile(e)
                                                        }
                                                        id="brideProfile"
                                                        disabled
                                                      />
                                                    </Col>
                                                    <Col
                                                      xl="3"
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="profileRemarks"
                                                        className="client-label"
                                                      >
                                                        Profile Remarks
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="brideRemarks"
                                                        value={
                                                          profileData.bride
                                                            .brideRemarks
                                                        }
                                                        // disabled={editButton}
                                                        onChange={(e) =>
                                                          handleChange(e)
                                                        }
                                                        placeholder="Enter Profile Remarks"
                                                        id="profileRemarks"
                                                      />
                                                    </Col>
                                                    <Col
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="brideProfile"
                                                        className="client-label"
                                                      >
                                                        Groom Profile
                                                      </Label>
                                                      <Select
                                                        name="groomProfile"
                                                        value={
                                                          // profileData.groom.
                                                          groomProfile
                                                        }
                                                        // options={clientProfileOptions}
                                                        options={
                                                          recordsMetaData
                                                            ? recordsMetaData.clientProfileOptions
                                                            : []
                                                        }
                                                        onChange={(e) =>
                                                          setGroomProfile(e)
                                                        }
                                                        id="groomProfile"
                                                      />
                                                    </Col>
                                                    <Col
                                                      xl="3"
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="profileRemarks"
                                                        className="client-label"
                                                      >
                                                        Profile Remarks
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="groomRemarks"
                                                        value={
                                                          profileData.groom
                                                            .groomRemarks
                                                        }
                                                        // disabled={editButton}
                                                        onChange={(e) =>
                                                          handleChange(e)
                                                        }
                                                        placeholder="Enter Profile Remarks"
                                                        id="profileRemarks"
                                                      />
                                                    </Col>
                                                    <Col
                                                      xl="3"
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="profileRemarks"
                                                        className="client-label"
                                                      >
                                                        Bride Insta Link
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="brideInstaLink"
                                                        value={
                                                          profileData.bride
                                                            .brideInstaLink
                                                        }
                                                        // disabled={editButton}
                                                        onChange={(e) =>
                                                          handleChange(e)
                                                        }
                                                        placeholder="Enter Bride Insta Link"
                                                        id="brideInstaLink"
                                                      />
                                                    </Col>
                                                    <Col
                                                      xl="3"
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="brideFbLink"
                                                        className="client-label"
                                                      >
                                                        Bride Fb Link
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="brideFbLink"
                                                        value={
                                                          profileData.bride
                                                            .brideFbLink
                                                        }
                                                        // disabled={editButton}
                                                        onChange={(e) =>
                                                          handleChange(e)
                                                        }
                                                        placeholder="Enter Bride Fb Link"
                                                        id="brideFbLink"
                                                      />
                                                    </Col>
                                                    <Col
                                                      xl="3"
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="groomInstaLink"
                                                        //className="client-label mx-2 mt-1"
                                                        className="client-label"
                                                      >
                                                        Groom Insta Link
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="groomInstaLink"
                                                        value={
                                                          profileData.groom
                                                            .groomInstaLink
                                                        }
                                                        // disabled={editButton}
                                                        onChange={(e) =>
                                                          handleChange(e)
                                                        }
                                                        placeholder="Enter Groom Insta Link"
                                                        id="grooomInstaLink"
                                                      />
                                                    </Col>
                                                    <Col
                                                      xl="3"
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <Label
                                                        for="groomFbLink"
                                                        className="client-label"
                                                      >
                                                        Groom Fb Link
                                                      </Label>
                                                      <Input
                                                        type="text"
                                                        name="groomFbLink"
                                                        value={
                                                          profileData.groom
                                                            .groomFbLink
                                                        }
                                                        // disabled={editButton}
                                                        onChange={(e) =>
                                                          handleChange(e)
                                                        }
                                                        placeholder="Enter Groom Fb Link"
                                                        id="grooomFbLink"
                                                      />
                                                    </Col>


                                                    <Col
                                                      xl="3"
                                                      lg="3"
                                                      md="3"
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <div className="d-flex justify-content-between">
                                                        <Label
                                                          for="uploadBrideInput"
                                                          className="client-label"
                                                        >
                                                          {"Bride Attachment (JPG/PNG)"}
                                                          <span className="required">*</span>
                                                        </Label>
                                                      </div>
                                                      <Button className="btn btn-warning position-relative fs-5">
                                                        <i className="fas fa-laptop"></i>
                                                        <Input
                                                          type="file"
                                                          name="uploadBrideInput"
                                                          accept="application/pdf, audio/mp3 , image/jpeg"
                                                          multiple
                                                          onChange={uploadBrideChange}
                                                          style={{
                                                            position: "absolute",
                                                            fontSize: "50px",
                                                            opacity: 0,
                                                            right: 0,
                                                            top: 0,
                                                          }}
                                                        />
                                                        <span className="position-absolute top-0 start-100 translate-middle badge bg-danger rounded-circle">
                                                          {fileLength ? fileLength : 0}
                                                        </span>
                                                      </Button>
                                                      <div className="text-decoration-underline text-danger">
                                                        {fileName || ""}
                                                      </div>

                                                    </Col>

                                                    <Col
                                                      xl={{ size: 3, offset: 3 }}
                                                      lg={{ size: 3, offset: 3 }}
                                                      md={{ size: 3, offset: 3 }}
                                                      sm="12"
                                                      xs="12"
                                                      className="mt-3"
                                                    >
                                                      <div className="d-flex justify-content-between">
                                                        <Label
                                                          for="uploadGroomInput"
                                                          className="client-label"
                                                        >
                                                          {"Groom Attachment (JPG/PNG)"}
                                                          <span className="required">*</span>
                                                        </Label>
                                                      </div>
                                                      <Button className="btn btn-warning position-relative fs-5">
                                                        <i className="fas fa-laptop"></i>
                                                        <Input
                                                          type="file"
                                                          name="uploadGroomInput"
                                                          accept="application/pdf, audio/mp3 , image/jpeg"
                                                          multiple
                                                          onChange={uploadGroomChange}
                                                          style={{
                                                            position: "absolute",
                                                            fontSize: "50px",
                                                            opacity: 0,
                                                            right: 0,
                                                            top: 0,
                                                          }}
                                                        />
                                                        <span className="position-absolute top-0 start-100 translate-middle badge bg-danger rounded-circle">
                                                          {fileGroomLength ? fileGroomLength : 0}
                                                        </span>
                                                      </Button>
                                                      <div className="text-decoration-underline text-danger">
                                                        {fileGroomName || ""}
                                                      </div>

                                                    </Col>

                                                    <Col
                                                      xl="12"
                                                      md="12"
                                                      xs="12"
                                                      lg="12"
                                                      sm="12"
                                                    >
                                                      <div className="client-details-submit">
                                                        {isEdit ? (
                                                          <>
                                                            <button
                                                              onClick={() => {
                                                                setOpenModal(
                                                                  false
                                                                )
                                                                // handleCancel()
                                                              }}
                                                              type="button"
                                                              className="btn btn-danger btn-label form-cancel-btn"
                                                            >
                                                              <i className="bx bx-block label-icon "></i>
                                                              Cancel
                                                            </button>
                                                            <button
                                                              type="submit"
                                                              onClick={(
                                                                client
                                                              ) => {
                                                                client.preventDefault()
                                                                // setOpenModal(false)
                                                                handleUpdate(
                                                                  client
                                                                )
                                                              }}
                                                              className="btn btn-success btn-label form-submit-btn"
                                                            >
                                                              <i className="bx bx-check-double label-icon"></i>
                                                              Update
                                                            </button>
                                                          </>
                                                        ) : (
                                                          <>
                                                            {" "}
                                                            <button
                                                              onClick={(
                                                                client
                                                              ) => {
                                                                setOpenModal(
                                                                  false
                                                                )
                                                                // handleCancel()
                                                                client.preventDefault()
                                                              }}
                                                              type="button"
                                                              className="btn btn-danger btn-label form-cancel-btn"
                                                            >
                                                              <i className="bx bx-block label-icon "></i>
                                                              Cancel
                                                            </button>
                                                            <button
                                                              type="submit"
                                                              onClick={(e) => {
                                                                // client.preventDefault()
                                                                // setOpenModal(false)
                                                                handleSubmit(e)
                                                              }}
                                                              className="btn btn-success btn-label form-submit-btn"
                                                            >
                                                              <i className="bx bx-check-double label-icon"></i>
                                                              Submit
                                                            </button>
                                                          </>
                                                        )}
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </form>
                                              )}
                                            </Col >
                                          </>
                                        )
                                        }

                                        {/* Event Details Section */}
                                        <Col>
                                          {!isEmpty(record_client_profile) &&
                                            !isEmpty(leadDetails) &&
                                            leadDetails[0].leadType ==
                                            "nonWedding" &&
                                            moduleMode == "SALES" ? (
                                            ""
                                          ) : (
                                            <EventDetails
                                              // recordsMetaData={recordsMetaData}
                                              clientProfile={
                                                leadDetails && leadDetails
                                                // leadDetails &&
                                                // leadDetails
                                              }
                                              multiArrayLeadId={multipleLeadId}
                                              eventDataLoading={
                                                eventDataLoading
                                              }
                                              moduleMode={moduleModeData}
                                            />
                                          )}
                                        </Col>
                                        {/* <Col>
                                    <DataTable />
                                  </Col> */}
                                      </>
                                    )
                                  case "Follow-Up Details":
                                    return (
                                      <>
                                        <FollowUpDetails
                                          recordsMetaData={recordsMetaData}
                                          recordClientProfile={
                                            record_client_profile
                                          }
                                          leadDetails={
                                            leadDetails && leadDetails
                                          }
                                          clientId={
                                            !isEmpty(leadByClientDetailsId)
                                              ? leadByClientDetailsId
                                              : customerClientId
                                          }
                                        />
                                      </>
                                    )
                                  case "Quotation":
                                    return (
                                      <Col>
                                        <QuotationDetails
                                          clientProfile={
                                            leadDetails && leadDetails
                                          }
                                          clientId={
                                            !isEmpty(leadByClientDetailsId)
                                              ? leadByClientDetailsId
                                              : customerClientId
                                          }
                                          recordsEventMetaData={recordsMetaData}
                                          loginAccess={loginAccess}
                                          recordArray={recordArray}
                                        />
                                      </Col>
                                    )
                                  case "Follow-Up History":
                                    return (
                                      <Col>
                                        <FollowUpHistory
                                          dateFormate={dateFormate}
                                        />
                                      </Col>
                                    )
                                  case "Notification":
                                    return (
                                      <Col>
                                        <Notification
                                          clientProfile={
                                            record_client_profile &&
                                            record_client_profile
                                            // leadDetails &&
                                            // leadDetails
                                          }
                                          profileData={
                                            clientDataTable && clientDataTable
                                          }
                                        />
                                      </Col>
                                    )
                                  case "Quotation History":
                                    return (
                                      <Col>
                                        <QuotationHistory />
                                      </Col>
                                    )
                                  case "Sales Entry":
                                    return (
                                      <Col>
                                        <Sales
                                          clientProfile={
                                            leadDetails && leadDetails
                                          }
                                          clientId={leadByClientDetailsId}
                                        />
                                      </Col>
                                    )
                                }
                              })()}
                            </Col>
                          )
                        case "Event Coordinator":
                          return (
                            <Col>
                              <Col md="12" lg="12" xl="12">
                                <Nav className="nav">
                                  {eventButtons.map((data, index) => {
                                    return (
                                      <button
                                        key={index}
                                        type="submit"
                                        className={
                                          menuName === "TeamSchedule" &&
                                            data.label === "Equipment Scheduling"
                                            ? "qc-approved disabled-button"
                                            : menuName ===
                                              "EquipmentSchedule" &&
                                              data.label === "Team Scheduling"
                                              ? "qc-approved disabled-button"
                                              : data.color
                                        }
                                        // className={data.color}
                                        style={{
                                          marginRight: "20px",
                                          marginTop: "10px",
                                        }}
                                        onClick={() => {
                                          setEventTab(data.label)
                                        }}
                                      >
                                        {data.label}
                                      </button>
                                    )
                                  })}
                                </Nav>
                              </Col>
                              {(() => {
                                switch (eventTab) {
                                  case "Client / Events":
                                    return (
                                      <>
                                        <Col>
                                          <EcClientDetails
                                            multiArrayLeadId={multipleLeadId}
                                            ecLoading={eventCoordinatorLoading}
                                          />
                                        </Col>
                                        <Col>
                                          <EcEventDetails
                                            // recordsMetaData={recordsMetaData}
                                            clientProfile={
                                              record_client_profile &&
                                              record_client_profile
                                            }
                                            multiArrayLeadId={multipleLeadId}
                                            ecLoading={eventCoordinatorLoading}
                                          />
                                        </Col>
                                      </>
                                    )
                                  case "Deliverables":
                                    return (
                                      <Col>
                                        <EcDeliverableDetails
                                          modeMenu={modeMenu}
                                        />
                                      </Col>
                                    )
                                  case "Service":
                                    return (
                                      <Col>
                                        <EcServiceDetails />
                                      </Col>
                                    )
                                  case "EC Followup":
                                    return (
                                      <Col>
                                        <ECFollowup modeMenu={modeMenu} />
                                      </Col>
                                    )
                                  case "Special Instruction":
                                    return (
                                      <Col>
                                        <SpecialInstruction
                                          modeMenu={modeMenu}
                                        />
                                      </Col>
                                    )
                                  case "Client Check List":
                                    return (
                                      <Col>
                                        <EcClientCheckList
                                          modeMenu={modeMenu}
                                        />
                                      </Col>
                                    )
                                  case "Team Scheduling":
                                    return (
                                      <Col>
                                        <TeamSchedulingDetails
                                          clientProfile={
                                            record_client_profile &&
                                            record_client_profile
                                          }
                                          modeMenu={modeMenu}
                                        />
                                      </Col>
                                    )

                                  case "Equipment Scheduling":
                                    return (
                                      <Col>
                                        <EcEquipmentScheduling
                                          clientProfile={
                                            record_client_profile &&
                                            record_client_profile
                                          }
                                          modeMenu={modeMenu}
                                        />
                                      </Col>
                                    )
                                }
                              })()}
                            </Col>
                          )
                        case "Operations":
                          return (
                            <Col>
                              <Col md="12" lg="12" xl="12">
                                <Nav className="nav">
                                  {operationButtons.map((data, index) => {
                                    return (
                                      <button
                                        key={index}
                                        type="submit"
                                        className={data.color}
                                        style={{
                                          marginRight: "20px",
                                          marginTop: "10px",
                                          marginBottom: "10px",
                                        }}
                                        onClick={() => {
                                          setOperationTab(data.label)
                                        }}
                                      >
                                        {data.label}
                                      </button>
                                    )
                                  })}
                                </Nav>
                              </Col>
                              {(() => {
                                switch (operationTab) {
                                  case "Client / Events / SI":
                                    return (
                                      <>
                                        <Col>
                                          <EcClientDetails
                                            multiArrayLeadId={multipleLeadId}
                                            ecLoading={eventCoordinatorLoading}
                                          />
                                        </Col>
                                        <Col>
                                          <EcEventDetails
                                            // recordsMetaData={recordsMetaData}
                                            clientProfile={
                                              record_client_profile &&
                                              record_client_profile
                                            }
                                            multiArrayLeadId={multipleLeadId}
                                            ecLoading={eventCoordinatorLoading}
                                          />
                                        </Col>
                                        <Col>
                                          <OperationsSpecialInstructions
                                            modeMenu={modeMenu}
                                          />
                                        </Col>
                                      </>
                                    )
                                  case "Deliverables":
                                    return (
                                      <Col>
                                        <OperationsDeliverables />
                                      </Col>
                                    )
                                  case "Data Copy":
                                    return (
                                      <Col>
                                          <OperationsFirstSet />
                                      </Col>
                                    )
                                  case "App":
                                    return (
                                      <>
                                        <Col>
                                          <OperationsApp />
                                        </Col>
                                      </>
                                    )
                                  case "EC":
                                    return (
                                      <Col>
                                        <OperationsClientCheckListQuestions />
                                      </Col>
                                    )
                                  case "Follow-up":
                                    return (
                                      <Col>
                                        <OperationsFollowup
                                          modeMenu={modeMenu}
                                          record_client_profile={record_client_profile}
                                        />
                                      </Col>
                                    )

                                  case "First Set":
                                    return (
                                      <Col>
                                        <OperationsFirstSet />
                                      </Col>
                                    )
                                  case "Second Set":
                                    return (
                                      <Col>
                                        <OperationsSecondSet />
                                      </Col>
                                    )
                                  case "Print":
                                    return (
                                      <Col>
                                        <OperationsPrint />
                                      </Col>
                                    )
                                  case "Dispatch":
                                    return (
                                      <Col>
                                        <OperationsDispatch />
                                      </Col>
                                    )
                                  case "Call Recording":
                                    return (
                                      <Col>
                                        <OperationsCallRecording />
                                      </Col>
                                    )
                                    case "Review":
                                      return (
                                        <Col>
                                          <OperationsReviews/>
                                        </Col>
                                      )
                                }
                              })()}
                            </Col>
                          )
                        case "Data":
                          return (
                            <Col>
                              <Col md="12" lg="12" xl="12">
                                <Nav className="nav">
                                  {dataButtons.map((data, index) => {
                                    return (
                                      <button
                                        key={index}
                                        type="submit"
                                        className={data.color}
                                        style={{
                                          marginRight: "20px",
                                          marginTop: "10px",
                                          marginBottom: "10px",
                                        }}
                                        onClick={() => {
                                          setDataTab(data.label)
                                        }}
                                      >
                                        {data.label}
                                      </button>
                                    )
                                  })}
                                </Nav>
                              </Col>
                              {(() => {
                                switch (dataTab) {
                                  case "Data Copy":
                                    return (
                                      <>
                                        <Col>
                                          <CopyDataTeamScheduling
                                            clientProfile={
                                              record_client_profile &&
                                              record_client_profile
                                            }
                                            clientId={
                                              leadByClientDetailsId != undefined
                                                ? leadByClientDetailsId
                                                : customerClientId
                                            }
                                            modeMenu={modeMenu}
                                          />
                                        </Col>
                                      </>
                                    )
                                }
                              })()}
                            </Col>
                          )
                      }
                    })()}
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div >
      {/*  */}
      {followupHistoryModal && (
        <Modal show={followupHistoryModal} onHide={handleFollowupHistoryModal} size="lg">
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              minHeight: "65px",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            <Col
              xl="6"
              lg="6"
              md="6"
              sm="6"
              xs="6"
              className="d-flex flex-row"
            >
              <span>Followup History</span>
              {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
            </Col>
          </Modal.Header>
          <Modal.Body>

            <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">

              <Table responsive>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th >Followup Status</th>
                    <th >Followup Date</th>
                    <th >Followup No</th>
                    <th >Followup Mode</th>
                    <th >Followup Remarks</th>
                    <th >Followup Attachment</th>
                    <th>Future Followup Date</th>
                    <th>Future Followup Mode</th>
                    {/* <th>Future Followup Remarks</th> */}
                    <th>Future Followup Strategy</th>
                    <th>Strategy Remark</th>
                  </tr>
                </thead>
                <tbody>
                  {followup_history && !isEmpty(followup_history) ?
                    followup_history.map((item, index) => {

                      const attachment = !isEmpty(item.recordAttachment)
                        ? item.recordAttachment[0]
                        : ""
                      const attachExtension = !isEmpty(attachment)
                        ? attachment.split(".").pop()
                        : ""
                      const futureFollowupStrategyName = !isEmpty(item.futureFollowupStrategyName) ?
                        item.futureFollowupStrategyName.map(m => m).join(",") : "--"


                      const futureFollowupmodeName = !isEmpty(item.futureFollowupmodeName) ?
                        item.futureFollowupmodeName.map(m => m).join(",") : "--"

                      const followupStatusName = !isEmpty(item.followupStatusName) ?
                        item.followupStatusName.map(m => m).join(",") : "--"
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{followupStatusName}</td>
                          <td>{item.followupDate ? moment(item.followupDate).format(dateFormate) : "--"}</td>
                          <td>{item.followwupNo ? item.followwupNo : "--"}</td>
                          <td>{item.modeName ? item.modeName : "--"}</td>
                          <td>{item.remarks ? item.remarks : "--"}</td>
                          <td>
                            {" "}
                            {(attachment &&
                              attachExtension === "jpeg") ||
                              (attachment &&
                                attachExtension === "jpg") ||
                              (attachment &&
                                attachExtension === "png") ? (
                              <div className="d-flex flex-row align-items-center">
                                <a
                                  onClick={() =>
                                    window.open(
                                      attachment,
                                      "_blank"
                                    )
                                  }
                                >
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "#E40D8C",
                                    }}
                                  >
                                    View
                                  </span>
                                </a>

                              </div>
                            ) : (attachment &&
                              attachExtension === "mp3") ||
                              (attachment &&
                                attachExtension === "m4a") ||
                              (attachment &&
                                attachExtension === "mp4") ? (
                              <a href={attachment}>
                                <audio controls>
                                  <source
                                    src={attachment}
                                    type="audio/mpeg"
                                  />
                                  Your browser does not support the
                                  audio element.
                                </audio>
                              </a>
                            ) : (
                              "--"
                            )}
                          </td>
                          <td>{item.futurefollowupDate ? moment(item.futurefollowupDate).format(dateFormate) : "--"}</td>
                          <td>{futureFollowupmodeName}</td>
                          {/* //   <td>{item.futureFollowupRemarks ? item.futureFollowupRemarks : "--"}</td> */}
                          <td>{futureFollowupStrategyName}</td>
                          <td>{item.strategyRemark ? item.strategyRemark : "--"}</td>
                        </tr>)

                    }) :
                    <tr>
                      <td className="text-align-center" colSpan={11}>
                        No Records Found...
                      </td>
                    </tr>
                  }
                </tbody>
              </Table>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex flex-row">
              <Button
                variant="secondary"
                className="btn btn-danger"
                onClick={handleFollowupHistoryModal}
              >
                Close
              </Button>

            </div>
          </Modal.Footer>
        </Modal>
      )}
      {onlyEngagementModal && (
        <Modal size="md" show={onlyEngagementModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Confirm
          </Modal.Header>
          <Modal.Body>
            <Col lg="10" md="10" sm="10" xs="10" className=" mb-3">
              {`Are You Sure Do You Want To ${engageRemove == true ? "Remove" : "Update"} Only Engagement ?`}
            </Col>
            <Col lg="10" md="10" sm="10" xs="10" className="mt-3 mb-3">

              <Select
                type="text"
                name="mainEvent"
                value={mainEvent}
                // isMulti
                onChange={(e) => setMainEvent(e)}
                options={[{ label: 'Main Event Booked', value: 'mainEventBooked' },
                { label: 'Main Event Not Booked', value: 'mainEventNotBooked'},
                ]}
                placeholder="Select Main Event"
                classNamePrefix="select2-selection"
              />
              {/* {simpleEngageValidator.current.message(
                "mainEvent",
                mainEvent,
                "required"
              )} */}
            </Col>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setOnlyEngagementModal(false)}
            >
              No
            </Button>
            <Button
              variant="secondary"
              className="btn btn-success"
              data-bs-dismiss="modal"
              onClick={() => updateEngagement()}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {goodLookingClientModal && (
        <Modal size="md" show={goodLookingClientModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Confirm
          </Modal.Header>
          <Modal.Body>
            {`Are You Sure Do You Want To ${goodClientRemove == true ? "Remove" : "Update"} Good Looking Client ?`}

          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setGoodLookingClientModal(false)}
            >
              No
            </Button>
            <Button
              variant="secondary"
              className="btn btn-success"
              data-bs-dismiss="modal"
              onClick={() => {
                updateGoodLook()
              }}
            // onClick={() => setGoodLookingClientModal(false)}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {highEndClientModal && (
        <Modal size="md" show={highEndClientModal}>
          <Modal.Header
            style={{
              backgroundColor: "#E40D8C",
              color: "white",
              fontSize: "16px",
              fontWeight: "600",
            }}
          >
            Confirm
          </Modal.Header>
          <Modal.Body>
            {`Are You Sure Do You Want To ${highEndClientRemove == true ? "Remove" : "Update"} High End Client ?`}

          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="btn btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setHighEndClientModal(false)}
            >
              No
            </Button>
            <Button
              variant="secondary"
              className="btn btn-success"
              data-bs-dismiss="modal"
              onClick={() => {

                updateHighEnd()
              }}
            //  onClick={() => setHighEndClientModal(false)}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      < ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/*  */}
    </React.Fragment >
  )
}

ClientDetails.propTypes = {
  dispatch: PropTypes.func,
  record_client_details: PropTypes.array,
  record_profile: PropTypes.array,
  recordsMetaData: PropTypes.object,
  location: PropTypes.array,
  error: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
}

const mapStateToProps = (state) => ({
  clientProps: state.client.record_client_details,
  clientPropsId: state.client.record_client_profile_by_id,
  clientProfileProps: state.client.record_client_profile_by_id,
})

/**
 *
 * @param {function} dispatch
 * @returns
 */
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ClientDetails)
)
